import investmentProposal from "./investmentProposalPages.js";

export default {
  investmentProposal,
  admin: {
    disclaimer: "Aviso legal",
    enterText: "Introducir un texto",
    holdingDataAdjustments: {
      categorise: {
        allProducts: "Todos los productos",
        allProperties: "Todas las propiedades",
        applyFilters: "Aplicar filtros",
        autoFilledValue: "No se asignó ninguna categoría; se autocompletó con el valor base.",
        description:
          "Utilice esta página para asignar categorías estandarizadas a los valores de las propiedades en todos los productos con datos de tenencia.",
        filteredProducts: "Productos seleccionados",
        filteredProperties: "Propiedades seleccionadas",
        filterMissingCategories: "Mostrar solo sin categoría: ",
        filterMissingCategoriesTooltip: "Mostrar solo las filas sin una categoría asignada.",
        filterUnsavedModifications: "Mostrar solo sin guardar: ",
        filterUnsavedModificationsTooltip:
          "Mostrar solo las filas con una modificación no guardada.",
        removeCategory: "Eliminar esta categoría",
        title: "Categorizar datos de tenencia",
        unsavedChangesAlert: "Tiene cambios sin guardar. Si se va, se perderán.",
        columns: {
          category: "Categoría",
          productName: "Nombre del producto",
          property: "Propiedad",
          value: "Valor",
        },
        productsMultiselect: {
          placeholder: "Seleccionar productos a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
        propertiesMultiselect: {
          placeholder: "Seleccionar propiedades a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
      translate: {
        allProducts: "Todos los productos",
        allProperties: "Todas las propiedades",
        applyFilters: "Aplicar filtros",
        autoFilledValue: "No se asignó ninguna traducción; se autocompletó con la categoría base.",
        description:
          "Utilice esta página para asignar traducciones a los valores de las categorías en todos los productos y propiedades con datos de tenencia.",
        filteredProducts: "Productos seleccionados",
        filteredProperties: "Propiedades seleccionadas",
        filterMissingTranslations: "Mostrar solo sin traducir: ",
        filterMissingTranslationsTooltip:
          "Mostrar solo las filas con alguna traducción no asignada.",
        filterUnsavedModifications: "Mostrar solo sin guardar: ",
        filterUnsavedModificationsTooltip:
          "Mostrar solo las filas con una modificación no guardada.",
        langNotAvailable: "Este idioma no está disponible para este producto.",
        title: "Traducir categorización de datos de tenencia",
        unsavedChangesAlert: "Tiene cambios sin guardar. Si se va, se perderán.",
        columns: {
          category: "Categoría",
          productName: "Nombre del producto",
          property: "Propiedad",
        },
        productsMultiselect: {
          placeholder: "Seleccionar productos a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
        propertiesMultiselect: {
          placeholder: "Seleccionar propiedades a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
      override: {
        allProducts: "Todos los productos",
        applyFilters: "Aplicar filtros",
        filteredProducts: "Productos seleccionados",
        propertyNotAvailable: "La propiedad no está disponible para el producto.",
        filterPresentOverrides: "Mostrar solo anulados: ",
        filterPresentOverridesTooltip: "Mostrar solo las filas con algún valor anulado.",
        filterUnsavedModifications: "Mostrar solo sin guardar: ",
        filterUnsavedModificationsTooltip:
          "Mostrar solo las filas con una modificación no guardada.",
        overriddenTooltip: (ctx) => `Anulaciones: ${ctx.named("value")}`,
        textUniqueKeys:
          "Esta tabla muestra los valores de los datos de tenencia base para todos los productos disponibles en la plataforma. Cada entrada única se identifica por una combinación de 'Nombre del producto', 'Nombre de la tenencia', 'Moneda' e 'ISIN'.",
        textHowToSingleOverride:
          "Para ver o modificar las anulaciones de una fila, haga clic en ella para expandir los detalles. Los valores anulados que difieran de los valores base se resaltarán: el texto amarillo indica anulaciones y el texto en cursiva resalta las anulaciones no guardadas.",
        textHowToBulkOverride:
          "Si desea aplicar actualizaciones masivas, se recomienda descargar las anulaciones de los datos de tenencia actuales como un archivo CSV con el botón de exportar. Luego puede realizar ediciones con una herramienta de hoja de cálculo (por ejemplo, Microsoft Excel) y volver a cargar el CSV modificado en esta página.",
        title: "Anular datos de tenencia",
        unsavedChangesAlert: "Tiene cambios sin guardar. Si se va, se perderán.",
        columns: {
          productName: "Nombre del producto",
        },
        productsMultiselect: {
          placeholder: "Seleccionar productos a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
      },
    },
    operations: {
      bulkPriceDataUpdate: {
        benchmarks: "Referencias",
        benchmarkName: "Nombre de la referencia",
        products: "Productos",
        productName: "Nombre del producto",
        metaInfo: {
          title: "Admin - Operaciones - Actualización masiva de datos de precios",
        },
        dashboard: {
          createdAt: "Creado en",
          createdBy: "Creado por",
          downloadFile: "Descargar archivo",
          fileDownloadError: "Error al descargar el documento, contáctenos.",
          loadingOperations: "Cargando operaciones...",
          newUpdate: "Nueva actualización...",
          refreshButton: "Actualizar",
          status: "Estado",
          uploadedFile: "Archivo cargado",
        },
        dryRunError: {
          backToUploadCsvButton: "Volver a cargar CSV",
          csvParsingErrorTitle: "Error de análisis de CSV",
          csvParsingErrorText:
            "El archivo proporcionado no es un archivo CSV válido o no tiene el formato correcto. Asegúrese de que todas las filas tengan valores, que las columnas estén ordenadas correctamente y que no falten valores.",
          nanFoundTitle: "Valores vacíos encontrados",
          nanFoundText:
            "Se encontraron algunos valores vacíos. Asegúrese de que todas las filas y columnas contengan un valor.",
          numberFormatErrorTitle: "Error de formato de número",
          numberFormatErrorText:
            "No se pudieron analizar los números de su archivo. Asegúrese de que los números sigan el formato correcto: use solo caracteres numéricos estándar y use un punto (.) para los decimales. Evite cualquier otro carácter especial.",
          duplicateDateErrorTitle: "Error de fecha duplicada",
          duplicateDateErrorText: `Los siguientes ID contienen fechas duplicadas. Cada ID debe tener fechas únicas para cada entrada.`,
          unknownIdsTitle: "ID desconocidos",
          unknownIdsText: `No se reconocen los siguientes ID. Asegúrese de que solo se utilicen ID válidos de las tablas de esta página.`,
          unauthorizedTitle: "ID no autorizados",
          unauthorizedText: `No se permiten los siguientes ID para las actualizaciones.`,
        },
        preparationAndDryRun: {
          backToDashboardButton: "Volver al panel",
          idToUseInCsv: "ID para usar en CSV",
          uploadCsvForPreview: "Cargar CSV para vista previa...",
          title: "Cargar CSV para vista previa de datos",
          csvUploadDialog: {
            acceptText: "Generar vista previa",
            title: "Cargar CSV para vista previa",
            text: "Seleccione un archivo CSV para previsualizar las actualizaciones de precios y referencias. Esta prueba simulará los cambios, lo que le permitirá revisarlos en la siguiente pantalla antes de finalizar.",
          },
          explanation: {
            el1: 'La columna ID debe contener los valores que se encuentran en la columna "ID para usar en CSV" en las tablas siguientes.',
            el2: "La columna DATE debe seguir el formato AAAA-MM-DD (por ejemplo, 2023-10-15, 1999-01-31).",
            el3: "El PRECIO debe ser un valor decimal.",
            el4: "El PRECIO_AJUSTADO debe ser un valor decimal. Esta columna generalmente representa los precios ajustados por dividendos, divisiones y otros eventos.",
            para1:
              "Para actualizar los precios y las referencias de forma masiva, cargue un archivo CSV con tres o cuatro columnas: ID, FECHA, PRECIO y, opcionalmente, PRECIO_AJUSTADO. Se debe respetar el orden, así como la presencia de los encabezados en el CSV. Si no se proporciona la columna opcional, se asumirá que los precios ajustados son los mismos que los precios.",
            para2:
              "Todos los precios que se le permite actualizar, ya sean los precios de un producto o de una referencia, se muestran en la(s) tabla(s) a continuación. Si falta algo que esperaba ver, contáctenos.",
            tip: '<em>Sugerencia</em>: Haga clic <a href="/sample-bulk-price-data-update.csv" download><u>aquí</u></a> para descargar un archivo CSV de muestra como referencia.',
          },
        },
        reviewAndConfirm: {
          backToUploadCsvButton: "Volver a cargar CSV",
          confirmAndApplyChangesButton: "Confirmar y aplicar cambios",
          firstDate: "Primera fecha",
          id: "ID",
          lastDate: "Última fecha",
          name: "Nombre",
          numberOfRows: "Número de filas",
          reviewAndConfirmText:
            "Aquí tiene un resumen de las actualizaciones que se aplicarán. Tenga en cuenta que los precios programados para la actualización reemplazarán por completo los precios existentes, ya que los precios antiguos se eliminarán antes de que se inserten los nuevos. Una vez que haya revisado las modificaciones, confírmelas en la parte inferior.",
          title: "Revisar y confirmar actualizaciones de datos",
          successDialog: {
            title: "Operación iniciada",
            text: "¡La operación se ha iniciado correctamente!",
          },
        },
      },
      exports: {
        description:
          "Puede crear exportaciones de la plataforma para guardar todos los datos de la plataforma (precios, tenencias, documentos, etc.) en un solo archivo ZIP.",
        newExport: "Nueva exportación",
        refreshButton: "Actualizar",
        successText: "La exportación se inició correctamente. Pronto podrá descargarla.",
        table: {
          createdAt: "Creado en",
          createdBy: "Creado por",
          file: "Archivo",
          fileTooltip: "Descargar archivo",
          status: "Estado",
        },
      },
      generateReports: {
        allLanguages: "Todos los idiomas",
        allProducts: "Todos los productos",
        createdAt: "Creado en",
        createdBy: "Creado por",
        reportGenerationFilters: "Filtros de generación de informes",
        file: "Archivo",
        fileName: "Nombre de archivo",
        fileTooltip: "Descargar archivo",
        fileZipTooltip: "Descargar todos los informes como ZIP",
        finishedAt: "Terminado en",
        generationNotPossibleDate:
          "La última fecha seleccionada es anterior a la fecha de inicio del producto.",
        generationNotPossibleLang: "Este idioma no está disponible para el producto seleccionado.",
        generationNotPossibleReport:
          "El informe seleccionado no está disponible para el producto seleccionado.",
        generationPossible: "La generación de informes es posible.",
        generationWarningFileExists:
          "Ya existe un archivo con este nombre e idioma. Si continúa, se sobrescribirá el archivo existente.",
        generateSelectedReports: "Generar informes seleccionados",
        generationStatus: "Estado de generación",
        backToDashboardButton: "Volver al panel",
        backToFiltersButton: "Volver a los filtros",
        language: "Idioma",
        lastDateToInclude: "Última fecha a incluir",
        lastDayOfData: "Último día de datos",
        loadingOperations: "Cargando operaciones...",
        newButton: "Generar nuevos informes...",
        noReportsBecauseNoAccessToProducts:
          "No tiene acceso a ningún producto para el que se hayan generado esos informes.",
        preparingReportsGeneration: "Preparando la lista de informes para la generación...",
        product: "Producto",
        refreshButton: "Actualizar",
        requireLogin: "Requerir inicio de sesión para el acceso",
        saveInDocuments: "Guardar en la sección Documentos",
        disabledBecauseNotSavingInDocuments:
          "Solo aplicable al guardar informes en la sección Documentos.",
        selectReportsForGeneration: "Seleccionar informes para generar",
        selectLanguages: "Seleccionar idiomas",
        selectProducts: "Seleccionar productos",
        selectReport: "Seleccionar informe",
        setAsLastFactsheet: "Establecer como última factsheet para el producto",
        showAvailableReport: "Mostrar informes disponibles",
        status: "Estado",
        zipFile: "Archivo ZIP",
        langMultiselect: {
          placeholder: "Seleccionar idiomas a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
        metaInfo: {
          title: "Admin - Operaciones - Generar informes",
        },
        productsMultiselect: {
          placeholder: "Seleccionar productos a incluir",
          selectLabel: "Presione enter para seleccionar",
          deselectLabel: "Presione enter para eliminar",
          selectedLabel: "Seleccionado",
          limitText: (ctx) => `y ${ctx.named("count")} más`,
        },
        successDialog: {
          title: "Operación creada",
          text: "¡La operación se ha iniciado correctamente!",
        },
      },
      bulkComponentUpdate: {
        action: "Acción",
        actionIcons: {
          add: "Añadir",
          edit: "Editar",
          error: "Error",
        },
        backToDashboardButton: "Volver al panel",
        bulkUpdate: "Cargar CSV y ver los posibles cambios...",
        bulkUpdateShortDesc:
          "Añadir o actualizar componentes genéricos importando un CSV desde su dispositivo",
        bulkUpdateDesc: {
          action: "Proporcione el CSV para actualizar o añadir los componentes genéricos.",
          instructions:
            "El CSV debe tener 7 columnas que se correspondan con el ID del producto, el ID del componente, el tipo de componente, el idioma, la clave, el valor y la vista en orden.",
          trigger:
            "Después de cargar el archivo CSV, podrá revisar los componentes que se añadirán o modificarán. Si está satisfecho con los cambios propuestos, podrá confirmarlos para finalizar las actualizaciones de los componentes.",
        },
        componentId: "ID del componente",
        createdAt: "Creado en",
        createdBy: "Creado por",
        errorsIntro: "Aquí está la lista de reglas que el CSV viola:",
        errorListTitle: "El archivo CSV proporcionado contiene errores",
        importing: {
          sucessfulImport: "Los componentes están actualizados.",
          uknownFailure: "Error al importar componentes.",
        },
        importComponentsButton: "Confirmar y aplicar cambios",
        key: "Clave",
        lang: "Idioma",
        loadingOperations: "Cargando operaciones...",
        loadingPreview: "Cargando cambios...",
        metaInfo: {
          title: "Admin - Operaciones - Actualización masiva de componentes",
        },
        numComponents: "Número de componentes",
        numElements: "Número de elementos",
        view: "Vista",
        previewTitle: "Vista previa de los cambios que se realizarán",
        product: "Producto",
        rules: {
          allowedLang: "El idioma debe ser uno existente para el producto correspondiente.",
          columns:
            "Debe haber 7 columnas en el siguiente orden: ID de producto, ID de componente, tipo de componente, idioma, clave, valor, vista.",
          invalidFile:
            "No se puede analizar el archivo CSV. Asegúrese de tener el archivo CSV correcto.",
          keyDuplication: "Las claves no se pueden duplicar.",
          linking: "Los componentes vinculados no se pueden actualizar simultáneamente.",
          multipleTypes: "Se especificaron varios tipos para el mismo componente.",
          naValue: "El CSV proporcionado no puede contener valores NaN.",
          nonEditableComponent:
            "No se puede editar un componente porque es un componente predefinido o el tipo de componente especificado es incorrecto.",
          nonFloatValue: "La columna de valor en el caso de los gráficos debe contener números.",
          numRowsPerLang: "Debe haber el mismo número de filas para cada idioma.",
          productExists: "Los ID de producto deben ser válidos.",
          unsupportedView: "Vista no compatible.",
          unsupportedType:
            "Los tipos de componentes permitidos son: 'horizontal-bar-chart', 'vertical-bar-chart', 'pie-chart', 'donut-chart', 'table'.",
        },
        type: "Tipo",
        value: "Valor",
      },
    },
    platformSettings: {
      platformSettings: "Configuración de la plataforma",
      complianceTab: {
        checksActivated: "Controles activados",
        editTitle: "Editar conformidad",
        title: "Conformidad",
        investorProfile: {
          disclaimerTooltip:
            "Este texto se mostrará a los usuarios que lleguen a la plataforma y se les pregunte cuál es su perfil de inversor (tipo y país). Asegúrese de redactar un aviso legal apropiado y legal.",
          goToInvestorProfilePage: "Abrir página",
          seeInvestorProfilePage: "Ver página de perfil de inversor",
          showLogoOnInvestorProfile: "Mostrar logotipo en la página de perfil de inversor",
          title: "Perfil de inversor",
          tooltip:
            'Puede activar los controles de perfil de inversor, lo que significa que cuando un usuario llegue a su plataforma por primera vez, tendrá que seleccionar su tipo de inversor (minorista, profesional, institucional), así como su país. A continuación, puede configurar qué tipo de inversor y de qué país puede ver cada uno de sus productos/clases de acciones; esto se puede hacer en la sección Admin>Productos, en la pestaña "Restricciones de acceso", una vez que haya activado los controles aquí.',
        },
        notify: {
          saveSuccessText: "Su configuración de conformidad se actualizó correctamente.",
          saveSuccessTextWithLang: (ctx) =>
            `Su configuración de conformidad se actualizó correctamente (idioma: ${ctx.named("lang")}).`,
        },
        ombudsman: {
          title: "Texto del Defensor del Cliente",
          tooltip:
            "Si necesita tener una referencia a su Defensor del Cliente en esta plataforma, escriba el texto que se mostrará a los usuarios que consulten su Defensor del Cliente. Un enlace a este texto será visible en el pie de página de la plataforma, junto a la Política de privacidad.",
        },
        productDisclaimer: {
          title: "Aviso legal predeterminado del producto",
          tooltip:
            'Establezca un aviso legal predeterminado para el producto que se utilizará para todos los productos que no tengan un aviso legal específico. Puede establecer un aviso legal específico para el producto yendo a "Admin > Productos", luego seleccionando el producto que desee y estableciendo el aviso legal específico para el producto en la pestaña "General".',
        },
      },
      rolesTab: {
        editTitle: "Editar roles",
        title: "Roles",
        description:
          'Por defecto, solo existe el rol "admin", un rol que otorga derechos de administrador en todos los productos, así como acceso a la configuración de la plataforma. Puede ser útil tener roles más específicos, por ejemplo, dar a algunos usuarios permisos de gestión o de visualización solo para algunos productos. Para crear dichos roles, utilice la siguiente tabla. Tenga en cuenta que, una vez que haya guardado los roles, deberá ir a la página {0} para asignar los roles a los usuarios que desee.',
        roleNameValidationError: "Este nombre de rol ya es utilizado por otro rol.",
        permissions: {
          manage: "Gestionar",
          view: "Ver",
        },
        table: {
          roleNameHeader: "Nombre del rol",
          permissionHeader: "Permiso",
          productsHeader: "Productos",
          removeRoleTooltip: "Eliminar rol",
          addRoleTooltip: "Añadir rol",
          productsMultiselect: {
            placeholder: "Seleccionar producto",
            selectLabel: "Presione enter para seleccionar",
            deselectLabel: "Presione enter para eliminar",
            selectedLabel: "Seleccionado",
            limitText: "y {count} más",
          },
        },
        notify: {
          saveSuccessText: "Sus roles se actualizaron correctamente.",
        },
      },
      styleTab: {
        colorScheme: "Esquema de colores",
        colorSchemePicker: "Selector de esquema de colores",
        colorSchemeTooltip:
          "El esquema de colores se utiliza en toda la plataforma. Si no se proporcionan colores personalizados, se genera automáticamente un conjunto de tonos derivados del color primario de la plataforma. Este esquema de colores se aplica actualmente a los gráficos de pastel y donut.",
        editTitle: "Editar",
        title: "Estilo",
        notify: {
          saveSuccessText: "El estilo se actualizó correctamente.",
        },
      },
      metaInfo: {
        title: "Admin - Configuración de la plataforma",
      },
    },
    products: {
      contactUsToFixError:
        "¡Contáctenos a través del formulario de contacto para solucionar este error!",
      langTabError: "Algunos campos no son válidos en el idioma:",
      overwriteDataAllShareClasses: "Sobrescribir datos de todas las clases de acciones",
      tabError: "Algunos campos no son válidos",
      unsavedChangesAlert: "Tiene cambios sin guardar. Si se va, se perderán.",
      accessRestrictionsTab: {
        allCountries: "Todos los países",
        countriesAllowedForInstitutionalInvestors:
          "Países permitidos para inversores institucionales",
        countriesAllowedForProfessionalInvestors: "Países permitidos para inversores profesionales",
        countriesAllowedForRetailInvestors: "Países permitidos para inversores minoristas",
        editAccessRestrictions: "Editar restricciones de acceso",
        title: "Restricciones de acceso",
        warningEnablingAccessRestrictions:
          'Para poder modificar las restricciones de acceso, active los controles de perfil de inversor en {0}, en la pestaña "Conformidad".',
      },
      detailsTab: {
        editDetails: "Editar detalles",
        key: "Clave",
        title: "Detalles",
        value: "Valor",
      },
      dialog: {
        saveFieldInAllShareClasses: {
          title: "Sobrescribir",
          text: "Va a sobrescribir este campo en todas las demás clases de acciones de este producto, no solo en la clase de acciones actual. ¿Está seguro?",
        },
        saveInAllShareClasses: {
          title: "Sobrescribir",
          text: (ctx) =>
            `Va a sobrescribir los datos de la "${ctx.named(
              "tabName"
            )}" de todas las demás clases de acciones de este producto con los datos de la "${ctx.named(
              "tabName"
            )}" de esta clase de acciones (no solo los últimos cambios que realizó). ¿Está seguro?`,
        },
      },
      followersTab: {
        addedByAdmin: "Añadido por el administrador",
        addFollowerButton: "Añadir un seguidor",
        email: "Correo electrónico",
        exportCsv: "Exportar como CSV",
        importCsv: "Importar desde CSV",
        noDataText: "Nadie sigue a este producto",
        product: "Producto",
        removeFollowerTooltip: "Eliminar seguidor para el producto correspondiente",
        sendEmail: "Enviar un correo electrónico",
        showAnyShareClass: "Mostrar seguidores de cualquier clase de acciones",
        title: "Seguidores",
        addFollowerPrompt: {
          email: "Correo electrónico del seguidor",
          emailAlreadyExists:
            "Alguien con este correo electrónico ya está siguiendo este producto.",
          file: "Archivo CSV",
          language: "Idioma del seguidor",
          text: "Antes de añadir un seguidor manualmente, debe asegurarse de que acepta recibir la información que planea enviarle.",
          titleAddFollower: "Añadir seguidor",
          titleImportFollowers: "Importar seguidores",
        },
        notify: {
          newFollowerAddedSuccess: "El nuevo seguidor se ha añadido correctamente.",
          newFollowerAddedError:
            "Hubo un problema al añadir el nuevo seguidor. Vuelva a intentarlo o contáctenos si el problema persiste.",
          noDataInCsv:
            "No hay correo electrónico para añadir (después de filtrar los correos electrónicos ya presentes).",
          noEmailHeader:
            "A su archivo le falta un encabezado de columna que represente los correos electrónicos. Los encabezados de columna aceptados son los siguientes (sin distinción entre mayúsculas y minúsculas): email o e-mail.",
          followerRemovedSuccess: "El seguidor se ha eliminado correctamente.",
          followerRemovedError:
            "Hubo un problema al eliminar el seguidor. Vuelva a intentarlo o contáctenos si el problema persiste.",
          wrongFormatEmails: (ctx) =>
            `Su archivo contiene correo(s) electrónico(s) con un formato incorrecto: ${ctx.named("emails")}`,
        },
        removeFollowerPrompt: {
          acceptText: "Eliminar seguidor",
          text: (ctx) =>
            `¿Está seguro de que desea eliminar a "${ctx.named(
              "followerEmail"
            )}" de los seguidores del producto "${ctx.named("productName")}"?`,
          title: "Eliminar seguidor",
        },
      },
      generalTab: {
        editGeneralField: "Editar campo general",
        visibility: "Visibilidad",
        visibilityProductTooltip:
          "Define quién puede ver el producto: Público (todos los usuarios) o Privado (solo gestores y espectadores).",
        visibilityPublic: "Público",
        visibilityPrivate: "Privado",
        icon: "Icono",
        isin: "ISIN",
        title: "General",
      },
      permalinksTab: {
        title: "Permalinks",
        lastFactsheet: {
          title: "Última ficha informativa",
          noPermalink:
            "No hay ningún documento establecido como última ficha informativa para este producto, por lo que aún no hay ningún enlace permanente disponible.",
        },
        specificDocument: {
          title: "Documento específico",
          noDocuments: "No hay documentos disponibles para este producto.",
        },
      },
      holdingDataTab: {
        title: "Datos de tenencia",
        noHoldingData: "No hay datos de tenencia disponibles para este producto.",
        issuePartialHoldingDataSetup:
          "La configuración de los datos de tenencia está incompleta y, por lo tanto, no está disponible. Póngase en contacto con el equipo de Alquant si encuentra este problema.",
        launchHoldingUpdateButton: "Iniciar actualización",
        launchHoldingUpdateTooltip:
          "Al hacer clic en este botón, se fuerza una actualización obteniendo los datos más recientes de la fuente normalmente usada para la actualización automática diaria. Los datos pueden tardar unos minutos en obtenerse y actualizarse.",
        launchHoldingUpdateRunningTooltip: "Los datos de tenencia se están obteniendo actualmente.",
        refreshButton: "Actualizar",
        showMissingManualPropertyData: "Mostrar filas con datos manuales faltantes: ",
        showMissingManualPropertyDataTooltip:
          "Alternar para resaltar los componentes a los que les faltan valores para cualquier propiedad manual.",
        showTransformedData: "Mostrar datos transformados: ",
        switchRawTransformedDataTooltip:
          "Active este botón para mostrar los datos transformados. Esta vista aplica categorizaciones, reemplazos y traducciones a los datos y sus propiedades. Nota: excepto para la selección de fechas y la búsqueda, las interacciones solo están disponibles en la vista sin transformar.",
        columns: {
          value: "Valor",
          weight: "Peso",
        },
        notify: {
          launchSuccessText:
            "La actualización de los datos de tenencia se inició correctamente. Actualiza en unos minutos para ver los resultados.",
          launchErrorText:
            "Error al iniciar la actualización de los datos de tenencia, por favor contáctanos.",
        },
      },
      keyCharacteristicsTab: {
        header: "Encabezado",
        icon: "Icono",
        paragraph: "Párrafo",
        title: "Características clave",
      },
      metaInfo: {
        title: "Admin - Configuración de productos",
      },
      notify: {
        productSaveSuccess:
          "Su configuración de producto se ha actualizado correctamente. | Su configuración de productos se ha actualizado correctamente.",
      },
      priceDataTab: {
        title: "Datos de precios",
        noPriceData: "No hay datos de precios disponibles para este producto.",
        benchmarks: {
          title: "Referencias",
        },
        product: {
          title: "Producto",
        },
      },
      selectCard: {
        loadingProducts: "Cargando productos...",
        loadingShareClasses: "Cargando clases de acciones...",
        noProducts: "No tiene productos.",
        selectProduct: "Seleccionar un producto",
        selectShareClass: "Seleccionar una clase de acciones",
      },
    },
    users: {
      tabName: "Lista de usuarios",
      company: "Empresa",
      country: "País",
      email: "Correo electrónico",
      emailCopied: "El correo electrónico se ha copiado.",
      investorType: "Tipo de inversor",
      name: "Nombre",
      lastVisit: "Última visita",
      phone: "Teléfono",
      roles: "Roles",
      metaInfo: {
        title: "Admin - Lista de usuarios",
      },
    },
  },
  auth: {
    email: "Correo electrónico",
    errorAlreadyEmailAndPasswordRegister:
      "Ya está registrado con este correo electrónico y una contraseña. Inicie sesión con este correo electrónico y su contraseña.",
    errorInternal: "Se produjo un error interno. Contáctenos.",
    or: "o",
    password: "Contraseña",
    login: {
      errorAccountNotExist:
        "No tiene una cuenta en esta plataforma, por favor cree una cuenta y vuelva a intentarlo.",
      errorInvalidLoginCredentials:
        "Las credenciales proporcionadas no corresponden a ninguna de nuestras cuentas de usuario. Esta discrepancia podría deberse a un correo electrónico o una contraseña incorrectos, a la ausencia de una cuenta asociada al correo electrónico introducido o a la posibilidad de que el correo electrónico esté vinculado a un método de inicio de sesión alternativo (como Google). Verifique su información y vuelva a intentarlo o cree una cuenta si es necesario.",
      errorNeedEmailVerification:
        "Necesita verificar su correo electrónico antes de intentar conectarse a nuestra plataforma. Por favor, revise sus correos electrónicos (y su carpeta de spam) para encontrar el correo. Si no lo encuentra, restablezca su contraseña.",
      noAccountYet: "¿Aún no tiene una cuenta?",
      rememberMe: "Recordarme",
      welcomeBack: "Bienvenido de nuevo, inicie sesión en su cuenta.",
      dialog: {
        alreadyLoggedInText: "¡Ya ha iniciado sesión!",
      },
      metaInfo: { title: "Plataforma - Iniciar sesión" },
      notify: {
        newAccessRight: {
          title: "Nuevos derechos de acceso",
          text: "Se ha cerrado la sesión automáticamente porque se le han otorgado nuevos derechos de acceso que requieren un nuevo inicio de sesión para ser validados.",
        },
        registrationSuccess: {
          title: "Registro exitoso",
          text: "Registro exitoso, le enviamos un mensaje para validar su dirección de correo electrónico, ¡revise su bandeja de entrada!",
        },
        requiresRecentLogin: {
          title: "Reautenticación requerida",
          text: "Para continuar con esta acción, vuelva a iniciar sesión, ya que su sesión ha caducado. Una vez reautenticado, puede volver a intentar la acción.",
        },
        unexpectedError: {
          title: "Error inesperado",
          text: "Se produjo un error inesperado. Vuelva a iniciar sesión. Si el problema persiste, póngase en contacto con el soporte técnico para obtener ayuda.",
        },
      },
    },
    login2fa: {
      enterCode: "Por favor, introduzca el código de 6 dígitos de su aplicación de autenticación.",
      incorrectCode: "El código no es correcto. Por favor, vuelva a intentarlo.",
      title: "Autenticación de 2 factores",
      verify: "Verificar",
      verifying: "Verificando...",
    },
    register: {
      alreadyRegistered: "¿Ya está registrado?",
      confirmPassword: "Confirmar contraseña",
      createAccount: "Crear cuenta",
      errorAlreadyEmailAndPasswordRegister:
        "Ya tiene una cuenta con este correo electrónico. Inicie sesión en su cuenta.",
      errorAlreadyGoogleRegister:
        "Ya está registrado con esta cuenta de Google. Inicie sesión con esta cuenta.",
      errorAlreadyMicrosoftRegister:
        "Ya está registrado con esta cuenta de Microsoft. Inicie sesión con esta cuenta.",
      fillBelowForm:
        'Rellene el siguiente formulario para crear una nueva cuenta. Los campos marcados con <span class="text-danger">*</span> son obligatorios.',
      registerWith: "Registrarse con: ",
      form: {
        agreeAdvertisementOnly:
          "Acepto explícitamente que toda la información proporcionada en esta plataforma es solo para fines informativos y publicitarios y no debe interpretarse como una oferta, consejo o recomendación para comprar o vender ningún valor en particular o para realizar ninguna transacción.",
        certifyAdult: "Certifico que tengo 18 años o más.",
        company: "Empresa",
        confirmPassword: "Confirmar contraseña",
        email: "Correo electrónico",
        firstName: "Nombre de pila",
        investorProfileCountry: "País",
        investorProfileType: "Tipo de inversor",
        lastName: "Apellido",
        needAgree: "Necesita aceptar",
        phone: "Teléfono",
        privacyPolicy: "política de privacidad",
        registeringAccept: "Al registrarse, acepta nuestros {0} y {1}.",
        termsOfUse: "términos de uso",
      },
      dialog: {
        alreadyLoggedInText: "¡Ya ha iniciado sesión!",
      },
      metaInfo: { title: "Plataforma - Registrarse" },
    },
    register2fa: {
      generatingQrCode: "Generando el código QR...",
      incorrectCode: "El código no es correcto. Por favor, vuelva a intentarlo.",
      need2fa:
        'Para acceder a la plataforma, configure la autenticación de 2 factores (2FA). Escanee el código QR a continuación o introduzca la clave secreta proporcionada en una aplicación de autenticación, como "Google Authenticator" o "Microsoft Authenticator".',
      title: "Configurar la autenticación de 2 factores",
      verify: "Verificar",
      verifying: "Verificando...",
    },
    resetPassword: {
      title: "Restablecer contraseña",
      sendEmail: "Enviar correo electrónico",
      dialog: {
        internalErrorText: "Se produjo un error interno. Contáctenos.",
        resetEmailSent: {
          title: "Correo electrónico de restablecimiento enviado",
          text: (ctx) =>
            `Se ha enviado un correo electrónico de restablecimiento a la bandeja de entrada de ${ctx.named(
              "email"
            )}. Si no aparece en breve, revise la bandeja de spam.`,
        },
        unknownEmail: {
          title: "El correo electrónico no existe",
          text: "El correo electrónico que proporcionó para restablecer la contraseña no existe. Para crear una cuenta con este correo electrónico, vaya a la página de registro.",
        },
      },
      metaInfo: { title: "Plataforma - Restablecer contraseña" },
    },
  },
  compliance: {
    investorProfile: {
      agreeAndConfirmSelection: "Aceptar y confirmar selección",
      byClickingAcceptDisclaimer:
        "Al hacer clic en el botón de abajo, confirmo que he leído, entendido y acepto el aviso legal anterior, así como la {0} y los {1} de esta plataforma.",
      pleaseChooseProfile:
        "Por favor, elija su país de residencia y perfil de inversor para continuar.",
      privacyPolicy: "política de privacidad",
      termsOfUse: "términos de uso",
      title: "Perfil de inversor",
      metaInfo: {
        title: "Plataforma - Perfil de inversor",
      },
    },
    ombudsman: {
      title: "Defensor del Cliente",
      metaInfo: {
        title: "Plataforma - Defensor del Cliente",
      },
    },
    privacyPolicy: {
      endDate: "Crissier, 31 de agosto de 2023",
      title: "Política de privacidad",
      metaInfo: { title: "Plataforma - Política de privacidad" },
      introductionParagraph: {
        title: "Introducción",
        para1:
          "Alquant SA (en lo sucesivo, Alquant, 'nosotros', 'nuestro') es la empresa que gestiona esta plataforma. Alquant SA respeta la privacidad de los usuarios de su presencia en la web. Esto significa que los datos personales se recopilan, procesan y utilizan de acuerdo con las disposiciones de la ley de protección de datos aplicable y sobre la base de esta política de privacidad.",
        para2:
          "Esto también se aplica - y en particular - a la cooperación con socios y terceros que utilizamos para la tramitación de contratos.",
        para3:
          "Al aceptar la siguiente política de privacidad, usted consiente los procesos de manejo de datos de Alquant detallados a continuación con respecto a la recopilación, el procesamiento y el uso de datos de acuerdo con las leyes de protección de datos y las siguientes disposiciones. Este consentimiento puede ser revocado en cualquier momento con efecto futuro.",
        para4:
          "Por lo tanto, nuestra práctica de protección de datos es coherente con la nueva Ley Federal de Protección de Datos (nFADP) y, cuando corresponda, el Reglamento General de Protección de Datos de la UE (GDPR).",
      },
      accountableAuthorityParagraph: {
        title: "Autoridad responsable / Representante de la UE",
        switzerland: "Suiza",
        euRepresentativeSub: {
          title: "Representante de la UE",
          para1:
            "En los casos a los que se refiere el Artículo 3, párrafo 2 del Reglamento (UE) 2016/679 (Reglamento General de Protección de Datos; GDPR) y de acuerdo con el Artículo 27 del GDPR, se designa como representante en la UE y en referencia al requisito suizo de una función de responsable de protección de datos de la nFADP:",
          para3: "Puede contactar con nuestro representante de la UE en: info(arroba)alquant.com",
        },
        accountableAuthoritySub: {
          email: "Correo electrónico",
          phone: "Teléfono",
          title: "Autoridad responsable y función de privacidad de datos según la nFADP suiza",
          para1: "La responsabilidad del procesamiento de datos personales recae en:",
          para3:
            "Para cualquier solicitud relacionada con la protección de su información personal, póngase en contacto con nuestro responsable de privacidad en: compliance(arroba)alquant.com.",
        },
      },
      personalDataParagraph: {
        title: "Datos personales",
        para1:
          "Los datos personales son cualquier información relativa a una persona física identificada o identificable; se considera que una persona física es identificable si puede ser identificada directa o indirectamente, en particular por referencia a un identificador como un nombre, un número de identificación, datos de ubicación, un identificador en línea o una o más características especiales que expresen la identidad física, fisiológica, genética, mental, económica, cultural o social de esta persona física. Esto incluye, por ejemplo, su nombre, su número de teléfono, su dirección, así como todos los datos de inventario que nos proporcione al registrarse y crear su cuenta de cliente. Los datos estadísticos o anonimizados, que recopilamos, por ejemplo, cuando visita nuestra tienda web y que no se pueden vincular directamente a su persona, no están cubiertos aquí.",
      },
      purposeOfDataCollectionParagraph: {
        title: "Fines de la recopilación de datos",
        para1:
          "a) La recopilación y el procesamiento de estos datos se llevan a cabo con el fin de cumplir con el contrato, para permitir el uso de nuestro sitio web (establecimiento de la conexión), para garantizar la seguridad y la estabilidad del sistema de forma permanente, para optimizar nuestra presencia en la web y para fines estadísticos internos. Recopilamos, almacenamos y procesamos datos personales únicamente de acuerdo con las regulaciones legales aplicables y en la medida en que sea necesario y requerido para cumplir y mejorar las obligaciones de rendimiento contractual entre nosotros y el usuario / cliente. Esto también incluye el almacenamiento de datos para cualquier reclamación de garantía después del final del contrato.",
        para2:
          "b) Además, utilizamos sus datos dentro del alcance de la ley aplicable para nuestros propios fines de marketing para optimizar nuestra presencia en la web y para llamar su atención sobre servicios que podrían ser de su particular interés.",
        para3:
          "c) Además, la recopilación, el procesamiento y el uso de datos personales solo se realizan si usted ha dado su consentimiento.",
      },
      newsletterParagraph: {
        title: "Boletín informativo",
        para1:
          "A Alquant le gusta informarle regularmente sobre temas y proyectos actuales relacionados con nuestro campo de actividad a través del boletín informativo. Solo recibirá un boletín de nuestra parte si lo solicita expresamente. Utilizamos el proceso de suscripción voluntaria para enviar el boletín, lo que significa que recibirá nuestro boletín por correo electrónico siempre que se haya registrado previamente de forma explícita para la entrega del boletín. Cuando se haya registrado en el boletín, su dirección de correo electrónico se utilizará junto con su consentimiento para nuestros propios fines promocionales hasta que se dé de baja del boletín. Puede darse de baja en cualquier momento enviando un correo electrónico que lo especifique a nuestra dirección de contacto info(arroba)alquant.com. Tenemos derecho a encargar a terceros el manejo técnico de las actividades promocionales y tenemos derecho a transmitir sus datos para este fin.",
        para2:
          "Los datos que proporcione al registrarse en el boletín (nombre y dirección de correo electrónico) se almacenarán y utilizarán únicamente para enviar el boletín.",
      },
      legalBasisParagraph: {
        title: "Base legal para el procesamiento",
        para1:
          "Procesamos sus datos personales principalmente para cumplir con las obligaciones contractuales y nuestras obligaciones legales. Además, al aceptar esta política de privacidad, usted consiente todas las operaciones de procesamiento especificadas en esta política de privacidad. Por supuesto, puede revocar su consentimiento en cualquier momento; una declaración a compliance(arroba)alquant.com es suficiente. Cualquier procesamiento realizado hasta este momento no se verá afectado por su cancelación.",
      },
      legitimateInterestParagraph: {
        title: "Intereses legítimos para el procesamiento",
        para1:
          "Además de la base legal mencionada para el procesamiento de datos, también procesamos datos en base a nuestros intereses legítimos. Esto se aplica en particular, pero no se limita a, el procesamiento para fines de marketing y promoción. Perseguimos, en particular, los siguientes intereses:",
        list1: {
          el1: "garantizar el uso potencial del sitio web",
          el2: "prevenir el fraude",
          el3: "garantizar la seguridad y la estabilidad de los sistemas de TI",
          el4: "nuestros propios fines de marketing",
          el5: "fines estadísticos internos",
        },
      },
      disclosureParagraph: {
        title: "Divulgación",
        para1:
          "Solo divulgamos sus datos personales si ha dado su consentimiento expreso, si existe una obligación legal de hacerlo o si esto es necesario para hacer valer nuestros derechos, en particular, para hacer valer las reclamaciones derivadas de la relación contractual. Además, divulgamos sus datos a terceros, en la medida en que sea necesario para la ejecución del contrato. Para este fin, divulgamos los datos requeridos a filiales, empresas de transporte, bancos y otros proveedores de servicios. Estos proveedores de servicios utilizan sus datos exclusivamente para el procesamiento de pedidos y no para otros fines. Además, utilizamos algunos servicios proporcionados por proveedores de servicios externos para optimizar su visita a nuestro sitio web. Se garantiza (contractualmente) que estos proveedores de servicios tratan sus datos de forma confidencial y de acuerdo con las regulaciones legales aplicables, y que sus datos solo se utilizan para el fin del servicio respectivo. Cualquier transferencia o reventa de los datos a terceros por parte de Alquant más allá de las disposiciones de esta política de privacidad está excluida a menos que el usuario haya dado su consentimiento expreso para la divulgación de sus datos. En este caso, el usuario puede revocar este consentimiento en cualquier momento. Las operaciones de procesamiento realizadas anteriormente en base a su consentimiento no se verán afectadas.",
        para2:
          "Alquant tiene derecho a transmitir sus datos personales a terceros en el extranjero si esto es necesario para la ejecución del contrato. Estos terceros están obligados al mismo nivel de protección de datos que el proveedor. Si el nivel de protección de datos en un país no corresponde al nivel suizo, nos aseguramos contractualmente de que la protección de sus datos personales corresponda en todo momento a la de Suiza.",
      },
      singleSignOnProcedureParagraph: {
        title: "Uso de procedimientos de inicio de sesión único",
        para1:
          "En nuestro sitio web, si tiene un perfil de Google o Microsoft, puede registrarse para crear una cuenta de cliente o registrarse utilizando el complemento social con la técnica de inicio de sesión único. Los complementos están etiquetados con el logotipo del proveedor.",
        para2:
          "Cuando acceda a nuestros sitios web que contengan dicho complemento, su navegador establecerá una conexión directa con los ordenadores del proveedor. El contenido del complemento se transmite desde el sitio del proveedor directamente a su navegador, que lo integra en el sitio web. Al integrar los complementos, el proveedor recibe la información de que usted ha accedido a nuestro sitio web. Si ha iniciado sesión simultáneamente en el proveedor, este puede asignar la visita a su perfil.",
        para3:
          "Si no desea que el proveedor recopile datos sobre usted a través de nuestro sitio web, debe cerrar la sesión en el proveedor antes de visitar nuestro sitio web. Incluso si ha cerrado la sesión, los proveedores recopilan datos anonimizados a través de complementos sociales que configuran una cookie para usted. Si inicia sesión en el proveedor en un momento posterior, estos datos pueden asignarse a su perfil.",
        para4:
          "Si se proporciona un inicio de sesión a través de un servicio de inicio de sesión social, por ejemplo, Google Connect, se intercambian datos entre el proveedor y nuestro sitio web. En el caso de Google Connect, pueden ser, por ejemplo, datos de su perfil público de Google. Al utilizar dichos servicios de inicio de sesión, acepta la transferencia de datos.",
        para5:
          "Consulte los avisos de protección de datos del proveedor para conocer el propósito y el alcance de la recopilación de datos y el procesamiento posterior de sus datos por parte del proveedor, así como sus respectivos derechos y opciones de configuración para proteger su privacidad.",
        para7:
          'Si no desea que el proveedor recopile datos sobre usted a través de estas cookies, puede seleccionar la función "bloquear cookies de proveedores de terceros" en la configuración de su navegador. En ese caso, si hay contenido incrustado de otros proveedores, el navegador no enviará ninguna cookie al servidor.',
      },
      durationOfRetentionParagraph: {
        title: "Duración de la retención",
        para1:
          "Conservamos sus datos personales durante el tiempo que sea necesario para cumplir con las leyes aplicables, o como consideremos apropiado, o durante el tiempo que sea necesario para los fines para los que fueron recopilados. Bloquearemos o eliminaremos sus datos personales tan pronto como ya no sean necesarios y definitivamente al expirar el período de retención máximo legal.",
        para2:
          "Puede solicitar la eliminación de sus datos personales en cualquier momento enviándonos una solicitud correspondiente a compliance(arroba)alquant.com. Cumpliremos con su solicitud de inmediato, siempre que no estemos obligados a conservarlos por otras razones o los necesitemos, por ejemplo, para la aplicación de reclamaciones.",
      },
      furtherDataSourcesParagraph: {
        title: "Otras fuentes de datos",
        para1:
          "Además de los datos que recopilamos directamente de usted, también obtenemos datos de registros públicos (como el Registro Mercantil) y de proveedores de terceros.",
        para2:
          "Dado que las fuentes de datos varían según el cliente, no se puede dar información general sobre dichas fuentes. Si lo desea, estamos dispuestos a revelarle nuestras fuentes de datos en detalle.",
      },
      userRightsParagraph: {
        title: "Derechos del usuario",
        rightRevocationSub: {
          title: "Derecho de revocación",
          para1:
            "En la medida en que nos haya dado su consentimiento para recopilar, almacenar y utilizar datos personales con respecto al sitio web o a nuestros servicios, puede revocar este consentimiento en cualquier momento. La revocación puede enviarse por correo electrónico o por escrito al contacto anterior en la sección 2: Autoridad responsable. Los efectos de la revocación se limitan al almacenamiento y uso de datos personales, que no pueden almacenarse y utilizarse sin su consentimiento previo basado en el permiso legal. La revocación tampoco tiene efecto sobre los procedimientos de procesamiento anteriores realizados sobre la base del consentimiento.",
        },
        furtherRightsSub: {
          title: "Otros derechos",
          informationSub: {
            title: "Información",
            para1:
              "A petición por escrito, le daremos información en cualquier momento sobre sus datos personales almacenados. La solicitud de información debe hacerse por escrito y con prueba de identidad (copia del DNI, pasaporte u otro documento de identificación oficial). El ejercicio de este derecho es gratuito una vez al año; para cualquier solicitud posterior, nos reservamos el derecho de cobrar por los costes incurridos.",
          },
          correctionSub: {
            title: "Corrección, eliminación, restricción del procesamiento",
            para1:
              "Además, tiene la opción de que corrijamos, bloqueemos o eliminemos sus datos personales en cualquier momento. Póngase en contacto con la autoridad interna, cuyos detalles se pueden encontrar en la sección 2. Se excluyen de la eliminación únicamente los datos que necesitamos para la finalización de tareas pendientes o para la aplicación de derechos y reclamaciones existentes, también los datos que estamos obligados a conservar debido a las regulaciones legales. Dichos datos serán bloqueados.",
          },
          rightAppealSub: {
            title: "Derecho de apelación",
            para1:
              "Damos gran importancia a la salvaguarda de los derechos de nuestros clientes y, por lo tanto, también a la protección de sus datos personales. Sin embargo, si cree que procesamos sus datos de forma ilegal, puede contactarnos en cualquier momento en el +41 41 661 23 45 o por correo electrónico compliance(arroba)alquant.com con los detalles de su inquietud. Atenderemos sus inquietudes lo mejor que podamos.",
            para2:
              "Si, en contra de lo esperado, nuestro servicio al cliente no puede proporcionarle una asistencia satisfactoria, puede enviar su inquietud al Supervisor Federal de Protección de Datos en cualquier momento como una queja formal, que luego se investigará.",
          },
          dataPortabilitySub: {
            title: "Portabilidad de datos",
            para1:
              "A petición por escrito, también tiene derecho a recibir datos personales relacionados con usted en un formato estructurado, actual y legible por máquina (archivo pdf) para su transmisión a un tercero. Nos reservamos el derecho de cobrar por los costes incurridos.",
          },
        },
      },
      cookiesParagraph: {
        title: "Uso de cookies",
        para1:
          "Para mejorar nuestra gama de productos, utilizamos cookies en nuestro sitio web. Una cookie es un pequeño archivo de texto que se transfiere a su ordenador cuando navega por nuestras páginas. Una cookie solo puede contener información que le enviamos a su dispositivo electrónico; no se pueden utilizar para leer datos personales. Si acepta las cookies en nuestro sitio, no tenemos acceso a su información personal, pero con la ayuda de las cookies podemos identificar su ordenador. No se almacenan datos personales en las cookies utilizadas, por lo que no podemos sacar conclusiones sobre su identidad mediante la tecnología de cookies. Solo se genera información seudonimizada.",
        para2: "Utilizamos cookies para verificar que cumple con nuestros Términos de uso.",
        para3:
          "Utilizamos cookies temporales basadas en la sesión: estas no permanecen en su ordenador. Cuando abandone nuestras páginas, la cookie temporal también se eliminará. Con la ayuda de la información recopilada, podemos analizar los patrones y las estructuras de uso de nuestro sitio web y optimizarlo mejorando el contenido o la personalización y simplificando el uso.",
        para4:
          "Además, utilizamos cookies persistentes: estas permanecen en su ordenador para simplificar la compra, la personalización y los servicios de registro en su próxima visita. Por ejemplo, estas cookies pueden registrar lo que ha elegido comprar mientras continúa comprando. Además, solo necesita introducir su contraseña una vez en las páginas web que requieren inicio de sesión. Las cookies persistentes pueden ser eliminadas manualmente por el usuario. Se eliminan solas después de que haya transcurrido un tiempo determinado.",
        para5:
          "Las cookies también son utilizadas por algunos de nuestros socios publicitarios (cookies de terceros). Estas cookies nos ayudan a adaptar nuestro sitio a las necesidades específicas de nuestros clientes, por ejemplo, mostrando anuncios que realmente podrían interesarle. El uso de estas cookies nos permite recopilar información sobre los productos que ha visto o buscado o las páginas que ha visitado anteriormente. Estas cookies se almacenan en su disco duro y se eliminan solas después de un tiempo determinado. Tampoco se almacena información personal en las cookies utilizadas por nuestros socios publicitarios. El uso está seudonimizado para que no se saque ninguna conclusión sobre su identidad.",
        para6:
          "La mayoría de los navegadores (como Firefox, Chrome, Internet Explorer, Safari, etc.) aceptan cookies de forma predeterminada. Puede permitir o bloquear las cookies temporales y persistentes en la configuración de seguridad, de forma independiente. Sin embargo, debemos señalar que algunas funciones no están disponibles en nuestro sitio web y es posible que algunos sitios web no se muestren correctamente si desactiva las cookies.",
        para7:
          "Los datos almacenados en nuestras cookies no se vincularán a sus datos personales (nombre, dirección, etc.) sin su consentimiento expreso.",
      },
      liabilityForLinksParagraph: {
        title: "Responsabilidad por los enlaces",
        para1:
          "Alquant declara expresamente que en el momento de establecer los enlaces no se podía identificar ningún contenido ilegal en las páginas a las que se iba a enlazar. No tenemos ninguna influencia en el diseño actual y futuro, el contenido o la autoría de las páginas enlazadas. Por lo tanto, por la presente nos disociamos expresamente de todos los contenidos de todas las páginas enlazadas que se cambian después de establecer el enlace. Esta declaración se aplica a todos los enlaces y referencias en nuestra presencia web. Con respecto a los contenidos ilegales, incorrectos o incompletos y, en particular, a los daños resultantes del uso o la no utilización de dicha información, solo el proveedor de la página a la que se hizo referencia es responsable y no quien simplemente establece el enlace a la publicación respectiva.",
      },
      webAnalysisParagraph: {
        title: "Análisis web",
        googleAnalyticsSub: {
          title: "Google Analytics",
          para1:
            "Este sitio web utiliza Google Analytics, un servicio de análisis web proporcionado por Google Inc. (Google) para el diseño de sitios web basado en las necesidades. Solo recibimos evaluaciones de datos sin referencias personales.",
          para2:
            "Google Analytics utiliza cookies: archivos de texto que se almacenan en su ordenador y que permiten el análisis de su uso del sitio web. La información generada por la cookie sobre su uso de este sitio web (incluida su dirección IP) se transmitirá y almacenará en los servidores de Google en los Estados Unidos. Se ha activado la anonimización de la IP en este sitio web para que la dirección IP de los usuarios de Google dentro de los Estados miembros de la Unión Europea o en otros estados contratantes del Acuerdo sobre el Espacio Económico Europeo se trunque antes de la transmisión. Solo en casos excepcionales se enviará la dirección IP completa a un servidor de Google en los EE. UU. y se truncará allí. Google utilizará esta información en nombre del operador del sitio web para evaluar el uso del sitio web por parte de los usuarios, para compilar informes sobre la actividad del sitio web y para proporcionar otros servicios al operador del sitio web relacionados con la actividad del sitio web y el uso de Internet. Google también transmitirá esta información a terceros si así lo exige la ley o si terceros procesan estos datos en nombre de Google. Google nunca asociará su dirección IP con otros datos de Google.",
          para3:
            "Puede evitar que se instalen cookies configurando el software de su navegador de forma adecuada. Sin embargo, debemos señalar que en este caso es posible que no pueda utilizar todas las funciones de este sitio web en toda su extensión. Al utilizar este sitio web, usted da su consentimiento para el procesamiento de los datos recopilados sobre usted por Google de la manera y para los fines establecidos anteriormente.",
          para4:
            'Además, puede evitar que Google recopile los datos generados por la cookie y relacionados con su uso del sitio web (incluida su dirección IP) y el procesamiento de estos datos por parte de Google descargando e instalando el complemento del navegador disponible en <a href="https://tools.google.com/dlpage/gaoptout" >https://tools.google.com/dlpage/gaoptout</a >. Para obtener más información sobre los Términos de uso y la Política de privacidad de Google Analytics, consulte',
          para5:
            '<a href="https://www.google.com/analytics/terms/" >https://www.google.com/analytics/terms/</a > y',
          para6:
            '<a href="https://policies.google.com/privacy?hl=en" >https://policies.google.com/privacy?hl=en</a >',
        },
        googleFontsSub: {
          title: "Fuentes de Google",
          para1:
            'Este sitio web también utiliza Fuentes de Google (Open Scans). Por razones técnicas, su dirección IP debe transmitirse a Google para que las fuentes se puedan transferir a su navegador. Para obtener más información sobre las Fuentes de Google, visite <a class="break-all" href="https://developers.google.com/fonts/faq#what_does_using_the_google_fonts_api_mean_for_the_privacy_of_my_users" >https://developers.google.com/fonts/faq#what_does_using_the_google_fonts_api_mean_for_the_privacy_of_my_users</a > .',
        },
      },
      securityMeasureParagraph: {
        title: "Medidas de seguridad",
        para1:
          "Aplicamos medidas de seguridad técnicas y organizativas para proteger adecuadamente su información personal del acceso no autorizado, el abuso, la manipulación accidental o intencionada, la pérdida o la destrucción. Para proteger su privacidad, utilizamos una conexión segura para nuestro sitio web, que puede ver por el 'https' (https significa Protocolo de transferencia de hipertexto seguro) al principio de la barra de direcciones de su navegador. De esta manera, la conexión se cifra a través de SSL/TSL y sus datos no pueden ser interceptados por terceros. Las medidas de seguridad técnicas para proteger sus datos personales se comprueban regularmente y, si es necesario, se actualizan. Estos principios también se aplican a las empresas que procesan y utilizan datos personales en nuestro nombre y de acuerdo con nuestras instrucciones.",
      },
      legalBasisGeneralDataProtectionParagraph: {
        title: "Base legal del Reglamento General de Protección de Datos",
        para1:
          "De acuerdo con las disposiciones del Reglamento General de Protección de Datos (GDPR) aplicable a partir del 25 de mayo de 2018, le informamos que su consentimiento para el envío a la dirección de correo electrónico que proporcione se otorgará en base al Art. 6, párrafo 1, letra a y el Art. 7 del GDPR. La lista de envío correspondiente se utiliza sobre la base de nuestros intereses legítimos de acuerdo con el Art. 6, párrafo 1, letra f del GDPR. Estamos interesados en utilizar un sitio web y un sistema seguros y fáciles de usar que sirvan a nuestros intereses comerciales, pero que también cumplan con las expectativas de nuestros usuarios y clientes.",
      },
      changesParagraph: {
        title: "Cambios",
        para1:
          "Nos reservamos el derecho de cambiar esta política de privacidad en cualquier momento. La política de privacidad no constituye ninguna relación legal contractual u otra relación legal formal con o en nombre de ninguna de las partes.",
      },
    },
    termsOfUse: {
      endDate: "Crissier, 3 de febrero de 2022",
      title: "Términos de uso",
      metaInfo: { title: "Plataforma - Términos de uso" },
      declarationOfAcceptanceParagraph: {
        title: "Declaración de aceptación por parte del usuario",
        para1:
          'Este sitio web es operado por Alquant SA. Al utilizar este sitio web (o una página desviada a esta dirección web; en lo sucesivo, denominado en total como el "sitio web de Alquant") usted confirma que ha leído, entendido y acepta los siguientes Términos de uso, incluidas las Condiciones legales. Si no acepta estos Términos de uso, no vuelva a visitar el sitio web de Alquant.',
      },
      limitedAccessParagraph: {
        title: "Acceso limitado",
        para1:
          "El sitio web de Alquant no está destinado a personas jurídicas y físicas que, por razones de nacionalidad, sede comercial, lugar de residencia o por cualquier otra razón, estén sujetas a un sistema legal que prohíba o restrinja en particular",
        list1: {
          el1: "la publicación de los contenidos,",
          el2: "el acceso al sitio web de Alquant,",
          el3: "las actividades de un proveedor de servicios financieros extranjero,",
          el4: "la admisión de productos financieros (por ejemplo, certificados o fondos).",
        },
        para3:
          "Además, no está destinado a ser utilizado por personas jurídicas o físicas en países donde Alquant SA o cualquier empresa asociada a ella no tenga el registro y la autorización necesarios para operar.",
        para4:
          "Las personas que estén sujetas a cualquiera o a todas estas restricciones no pueden acceder al sitio web de Alquant. Esto se aplica en particular a los ciudadanos de EE. UU., Reino Unido, Canadá, Japón, China y Singapur, o a las personas residentes en los países mencionados. Infórmese sobre las restricciones legales correspondientes en su país.",
        para5: "Aviso para inversores institucionales",
        para6:
          'Los productos financieros para inversores profesionales solo están disponibles para inversores cualificados. Según los términos del Art. 10, párrafo 3, de la Ley de inversiones de capital colectivo junto con el Art. 6 de la Ordenanza de inversiones de capital colectivo, los inversores cualificados incluyen inversores institucionales que tienen una tesorería profesional, a saber, bancos y comerciantes de valores (incluidos sus clientes que tienen un contrato de gestión de activos por escrito), fondos de pensiones, compañías de seguros, gestores de fondos y autoridades locales y cantonales, así como empresas industriales y comerciales. Al seleccionar "Inversores profesionales", usted confirma que es un inversor cualificado según la definición anterior.',
      },
      propertyRightsParagraph: {
        title: "Derechos de propiedad",
        para1:
          "Todos los elementos del sitio web de Alquant están protegidos como propiedad inmaterial y son propiedad de Alquant SA o de terceros. La utilización del sitio web de Alquant no implica la transferencia de ningún derecho, en particular de ningún derecho relacionado con software, nombres de marca o elementos del sitio web de Alquant. Las indicaciones de derechos de autor y los nombres de marca no pueden modificarse ni eliminarse. Los elementos del sitio web de Alquant no pueden reproducirse en su totalidad o en parte sin hacer referencia a la fuente completa. El contenido del sitio web de Alquant no puede reproducirse ni utilizarse con fines públicos o comerciales sin el previo acuerdo por escrito de Alquant SA.",
      },
      consultingReplacementParagraph: {
        title: "No sustituye a la consulta",
        para1:
          "La información y las opiniones publicadas en el sitio web de Alquant son de carácter general. No están destinadas ni son adecuadas para reemplazar la consulta individual por personal especializado que tendrá en cuenta las circunstancias reales que prevalecen en un caso individual dado. Por esta razón, no representan asesoramiento legal, fiscal, financiero, económico o de otro tipo y no deben utilizarse como ayuda para la inversión.",
      },
      noOffersParagraph: {
        title: "Sin ofertas",
        para1:
          "La información y las opiniones publicadas en el sitio web de Alquant no constituyen publicidad ni recomendaciones y no deben interpretarse como una demanda, una oferta o una invitación a presentar una oferta:",
        list1: {
          el1: "para adquirir o vender herramientas de inversión,",
          el2: "para realizar cualquier tipo de transacción,",
          el3: "para completar cualquier otro tipo de negocio legal.",
        },
        para3: "El único propósito del sitio web de Alquant es proporcionar información.",
      },
      futurePerformanceParagraph: {
        title: "Rendimiento futuro (indicación de riesgo)",
        para1:
          "El rendimiento futuro de una herramienta de inversión no se puede deducir de los movimientos de la tasa en el pasado, en otras palabras, el valor puede subir o bajar. Por lo tanto, el comportamiento del valor en el pasado no es una garantía para su valor futuro. En el caso de ciertas herramientas de inversión, la pérdida del capital total invertido también es posible en casos extremos. Además, las fluctuaciones en los tipos de cambio también pueden afectar a la inversión.",
      },
      noGuaranteeParagraph: {
        title: "Sin garantía",
        para1:
          "Alquant SA no ofrece garantías (incluida la responsabilidad frente a terceros) ni asegura",
        list1: {
          el1: "la actualidad, precisión, fiabilidad o integridad del contenido del sitio web de Alquant,",
          el2: "los resultados obtenidos utilizando el sitio web de Alquant,",
          el3: "el contenido de terceros que se encuentran en o son accesibles a través del sitio web de Alquant.",
        },
        para3: "Además, Alquant SA no será responsable ni puede garantizar que",
        list2: {
          el1: "las funciones del sitio web de Alquant funcionen sin fallos y estén disponibles sin interrupción,",
          el2: "el sitio web de Alquant y otros componentes utilizados a través del acceso al sitio web de Alquant estén libres de virus, etc.",
        },
        para5: "Alquant SA tampoco ofrece ninguna garantía para",
        list3: {
          el1: "el aumento o la estabilidad del valor del capital invertido en herramientas de inversión,",
          el2: "el nivel de dividendos futuros.",
        },
      },
      linksParagraph: {
        title: "Enlaces",
        para1:
          "Alquant SA no ha verificado los sitios web de terceros vinculados al sitio web de Alquant y no se hace responsable de la actualidad, precisión, fiabilidad, integridad o legalidad de los contenidos y ofertas de dichos sitios web. Por lo tanto, el usuario accede a dichas páginas web bajo su propio riesgo.",
        para2:
          "Los enlaces web solo se pueden incluir en sitios web fuera de un sitio web de Alquant con el acuerdo previo de Alquant SA.",
      },
      serviceChangesParagraph: {
        title: "Cambios en el servicio",
        para1:
          "Alquant SA puede cambiar, suspender o interrumpir cualquier aspecto de los Servicios en cualquier momento, incluida la disponibilidad de cualquier función de Servicio, base de datos o contenido. Alquant SA también puede imponer límites a ciertas funciones y servicios o restringir el acceso del usuario a todas o a partes de los Servicios sin previo aviso.",
        para2:
          "Alquant SA se reserva el derecho, a su sola discreción, de rescindir el acceso del usuario a los Servicios sin previo aviso.",
      },
      useOfInformationParagraph: {
        title: "Uso de la información",
        para1:
          "El usuario puede utilizar la Información publicada en el sitio web de Alquant solo para uso comercial interno o personal, no comercial. En ningún caso el usuario publicará, venderá, arrendará, difundirá, retransmitirá, redistribuirá, transmitirá, circulará o reproducirá, proporcionará o permitirá el acceso de ninguna otra manera a ninguna Información de **Alquant SA** en ningún formato a nadie; sin embargo, el usuario puede proporcionar Información a los usuarios, de forma no continua, utilizando solo los siguientes métodos limitados: (a) En anuncios escritos, correspondencia u otra literatura, o (b) durante conversaciones telefónicas de voz que no impliquen voz computarizada, sistemas automatizados de consulta de información o tecnologías similares.",
        para2:
          "El uso de herramientas de secuencias de comandos automatizadas para rastrear el sitio o intentar eludir la API está estrictamente prohibido y puede resultar en el bloqueo del sitio web de Alquant. Las solicitudes excesivas pueden resultar en la limitación del acceso de su cuenta a los datos.",
        para3:
          "El uso de formas de automatización que no se basan en la API, como el scripting del sitio web, está prohibido. El uso de estas técnicas puede resultar en la suspensión permanente de su cuenta.",
      },
      indemnificationParagraph: {
        title: "Indemnización",
        para1:
          "El usuario (y el fondo del usuario, si el usuario es un representante de un fondo) acepta conjunta y solidariamente indemnizar y eximir de responsabilidad a **Alquant SA**, y a sus agentes, proveedores de información y sus agentes, representantes, directores, funcionarios, accionistas, socios, predecesores, sucesores y cesionarios, de y contra cualquier reclamación o demanda, procedimiento, daños, responsabilidades, pérdidas o gastos, de reclamaciones realizadas por un tercero, que surjan del uso de la información de **Alquant SA** por parte del usuario que constituya una violación de los Términos de uso o un acto u omisión indebidos.",
        para2:
          "Si un usuario utiliza los Servicios o cualquier Contenido de forma distinta a la expresamente permitida en estos Términos de uso, puede violar los derechos de autor y otras leyes y puede ser objeto de sanciones. Sin limitar las oraciones anteriores, el usuario no podrá:",
        para3:
          "Participar o permitir la reventa, visualización, reproducción, copia, traducción, modificación, adaptación, creación de trabajos derivados, distribución, transmisión, transferencia, republicación, recopilación, descompilación o ingeniería inversa de los Servicios, cualquier Contenido, cualquier parte de los mismos, o cualquier dato, otro contenido o información proporcionada al usuario en relación con el uso de los Servicios por parte de Alquant SA o cualquiera de sus fuentes de terceros, en cualquier formato, medio o tecnología ahora existente o que se desarrolle en el futuro o a través de cualquier red, incluida una red de área local; Eliminar, ocultar o alterar cualquier aviso, aviso legal u otra divulgación adherida o contenida en los Servicios, incluido cualquier aviso de derechos de autor, marca comercial u otro aviso de derechos de propiedad o cualquier otro aviso legal adherido o mostrado en asociación con el Contenido; Crear un marco o utilizar técnicas de encuadre para encerrar cualquier parte de los Servicios o el Contenido, sin el consentimiento expreso previo por escrito de Alquant SA;",
        para4:
          "Hacerse pasar por cualquier persona, o declarar falsamente o tergiversar su afiliación con cualquier persona, en relación con cualquier uso de los Servicios; Incumplir o intentar incumplir la seguridad de los Servicios o cualquier red, servidores, datos u ordenadores u otro hardware relacionado o utilizado en relación con los Servicios o cualquiera de los Contenidos, ya sea operado o no por Alquant SA o un tercero; ni utilizar con, o distribuir a través de, los Servicios cualquier software u otras herramientas o dispositivos diseñados para interferir o comprometer la privacidad, la seguridad o el uso de los Servicios por parte de otros o las operaciones o activos de cualquier persona;",
        para5:
          "Violar cualquier ley aplicable, incluidas, entre otras, las leyes de valores y las leyes que rigen la actividad de inversión en cualquier país; Restringir o inhibir a cualquier otro usuario autorizado de usar y disfrutar de los Servicios; Publicar, vender, transmitir, reproducir, distribuir o explotar de cualquier manera el Contenido u otra información u otros materiales obtenidos a través de los Servicios con fines comerciales distintos a los expresamente permitidos por estos Términos de uso o por permiso expreso previo de Alquant SA.",
      },
      exclusionLiabilityParagraph: {
        title: "Exclusión de responsabilidad",
        para1:
          "Alquant SA o cualquier empresa, socio, junta directiva, empleado o representante vinculado a ella rechaza toda responsabilidad (incluida la negligencia y hacia terceros) por daños directos o indirectos o daños consecuentes que puedan ocurrir en relación directa o indirecta con la utilización del sitio web de Alquant.",
      },
      reservationsParagraph: {
        title: "Reservas",
        para1:
          "Alquant SA se reserva el derecho de modificar cualquier información, opiniones, rendimiento u otros datos, enlaces, etc. en cualquier momento sin previo aviso a los usuarios.",
        para2:
          "Además, los Términos de uso también pueden ser cambiados y el uso del sitio web de Alquant también puede ser restringido o terminado sin previo aviso.",
      },
      placeOfJurisdictionParagraph: {
        title: "Lugar de jurisdicción",
        para1:
          "En la medida en que surja una posición legal entre Alquant SA y los usuarios del sitio web de Alquant, esta está sujeta a la legislación suiza. El único lugar de jurisdicción será Lausana, Suiza.",
      },
    },
  },
  errors: {
    backHome: "Volver a inicio",
    error403: {
      paragraphWhenLoggedIn:
        "No tiene permiso para acceder a esta página. Si su perfil es aceptado, un administrador pronto le dará los derechos para acceder a ella. Vuelva a comprobarlo en los próximos 1 o 2 días hábiles.",
      paragraphWhenLoggedInWithContact: (ctx) =>
        `No tiene permiso para acceder a esta página. Si su perfil es aceptado, un administrador pronto le dará los derechos para acceder a ella. Vuelva a comprobarlo en los próximos 1 o 2 días hábiles. Si aún no ha recibido el acceso, por favor contáctenos: ${ctx.named(
          "contactEmail"
        )}.`,
      paragraphWhenNotLoggedIn:
        "Esta página requiere que esté autenticado para acceder a ella. Por favor, haga clic en el botón de abajo para iniciar sesión en su cuenta.",
      metaInfo: { title: "Plataforma - 403" },
    },
    error404: {
      paragraph: "La página a la que intenta acceder no existe.",
      title: "404 - Página no encontrada",
      metaInfo: { title: "Plataforma - 404" },
    },
    unauthorizedInvestorProfile: {
      modifyInvestorProfile: "Modificar perfil de inversor",
      title: "Perfil de inversión no autorizado",
      unfortunately:
        "Desafortunadamente, no puede tener acceso a esta página debido a su perfil de inversión.",
      metaInfo: { title: "Plataforma - Perfil de inversor no autorizado" },
    },
  },
  help: {
    contact: {
      address: "Dirección",
      introText:
        "No dude en utilizar este formulario para ponerse en contacto con nosotros. Estaremos encantados de atender cualquier sugerencia o responder a cualquier tipo de pregunta que pueda tener relacionada con esta plataforma y nuestros productos.",
      recaptchaProtect: "Este sitio está protegido por reCAPTCHA.",
      switzerland: "Suiza",
      title: "Contacto",
      dialog: {
        confirmMessage: {
          title: "Confirmar",
          text: "¿Quiere enviar este mensaje?",
        },
      },
      form: {
        country: "País",
        email: "Correo electrónico",
        enterMessage: "Introduzca su mensaje",
        exampleEmail: "john.doe@example.com",
        exampleName: "John Doe",
        investorProfileType: "Tipo de inversor",
        name: "Nombre",
        sendEmail: "Enviar correo electrónico",
      },
      metaInfo: { title: "Plataforma - Contacto" },
      notify: {
        errorMessage: {
          title: "Error al enviar el mensaje",
          text: "Lo sentimos, el mensaje no se pudo enviar. Vuelva a intentarlo más tarde o contáctenos directamente por correo electrónico.",
        },
        messageSent: {
          title: "Mensaje enviado",
          text: "El mensaje se envió correctamente. Nos pondremos en contacto con usted en 1 o 2 días hábiles.",
        },
      },
    },
    faq: {
      subtitle: "Consulte la siguiente lista para todas nuestras preguntas frecuentes.",
      title: "¿Tiene alguna pregunta?",
      metaInfo: { title: "Plataforma - Preguntas frecuentes" },
    },
    knowledgeBase: {
      investmentStrategyTechniques: "Técnicas de estrategia de inversión",
      metaInfoTerm: (ctx) => `Base de conocimientos - ${ctx.named("term")}`,
      monthlyDataBasis: "Calculado sobre la base de datos mensuales.",
      noResults: "No se encontraron resultados.",
      performanceMetrics: "Métricas de rendimiento",
      search: "Buscar",
      source: "Fuente",
      subtitle:
        "Encuentre una explicación sobre los términos técnicos generales, así como sobre algunas de nuestras técnicas que se muestran en esta plataforma.",
      title: "Bienvenido a nuestra base de conocimientos",
      alpha: {
        title: "Alfa",
        para1:
          "{0} se utiliza para medir el rendimiento superior que una estrategia o su gestor es capaz de generar en comparación con una referencia. El {1} describe el rendimiento después de descontar el entorno sin riesgo y el rendimiento relacionado con el mercado (prima de mercado * {2}).",
        para2:
          "El gráfico anterior muestra un valor de **alfa** del 4%, lo que significa que, dada la dependencia de la estrategia del mercado y el entorno actual de tipos de interés (rendimiento sin riesgo), pudo generar un 4% adicional de rendimiento en comparación con lo que se puede esperar.",
        para3:
          "Como se indica en el gráfico anterior, el componente **alfa** es el único impulsor del rendimiento que se puede atribuir a la habilidad del gestor. Además, indica que el **alfa** puede convertirse en un número negativo, lo que significa que el rendimiento se ha perdido a través de la gestión activa de la inversión. Dicho esto, un componente **alfa** positivo puede verse como el componente por el que un inversor está dispuesto a pagar una comisión.",
        para4:
          "Cuanto mayor sea el alfa, mejor será la estrategia. Un alfa alto significa que los gestores de activos lograron crear valor.",
      },
      annualizedReturn: {
        title: "Rendimiento anualizado",
        para1:
          "Los **rendimientos anualizados** son rendimientos acumulados reescalados a un período de un año. Esto permite a los inversores comparar mejor los rendimientos de diferentes activos que han poseído durante diferentes períodos de tiempo.",
        para2:
          "Alternativamente, los **rendimientos anualizados** también pueden interpretarse como el rendimiento de un año que un inversor habría obtenido en promedio al invertir durante un período de tiempo determinado.",
        para3:
          "En igualdad de condiciones, cuanto mayor sea el rendimiento anualizado, mejor será.",
      },
      annualizedVolatility: {
        title: "Volatilidad anualizada",
        para1:
          "La **volatilidad anualizada** es la volatilidad de una inversión que se reescala a un período de un año. La **volatilidad** en sí misma mide la magnitud de los movimientos de los precios. Más técnicamente, la **volatilidad** es una medida estadística de la dispersión de los rendimientos (específicamente la desviación estándar de los rendimientos) durante un período de tiempo. Cuanto mayor sea la **volatilidad**, más arriesgada será la inversión, porque cuanto mayor sea la **volatilidad**, más probable será que se produzcan oscilaciones más grandes.",
      },
      beta: {
        title: "Beta",
        para1:
          "El **beta** mide la dependencia de los rendimientos. Por lo general, se utiliza para medir la dependencia de un valor o una estrategia de inversión del rendimiento del mercado. Un **beta** más alto indica que el valor se mueve de forma más agresiva que el mercado, mientras que un **beta** bajo indica que el valor solo capta los rendimientos del mercado parcialmente. El gráfico a continuación muestra las líneas de tendencia de una inversión de alto beta y una de bajo beta y cómo se han comportado en comparación con el mercado, mientras que la pendiente de la línea de tendencia es el valor **beta**. La inversión de bajo beta muestra un **beta** &lt; 1, lo que significa que generalmente se mueve menos que el mercado pero en la misma dirección, mientras que la inversión de alto beta muestra un **beta** &gt; 1 y, por lo tanto, genera rendimientos más extremos que el mercado. Por lo tanto, los rendimientos en el gráfico están más dispersos que para la inversión de bajo beta.",
        para2:
          "Aunque rara vez se encuentran, existen valores **beta** negativos e indicarían una relación inversa con el mercado.",
        para3:
          "Al analizar una estrategia de inversión, los inversores buscan estrategias con un buen rendimiento y un beta bajo. Esta constelación indica que el rendimiento del gestor depende menos de los rendimientos del mercado y más de la habilidad del gestor.",
      },
      calmarRatio: {
        title: "Ratio de Calmar",
        para1:
          "Un ratio utilizado para determinar el rendimiento en relación con el riesgo de caída (drawdown) en un producto de inversión.",
        para2: "En igualdad de condiciones, cuanto mayor sea el ratio, mejor será la inversión.",
      },
      correlation: {
        title: "Correlación",
        para1:
          "El coeficiente de correlación de Pearson (PCC) es una medida estadística que evalúa la fuerza y la dirección de una relación lineal entre dos conjuntos de datos. Se calcula como la relación de la covarianza de las dos variables con el producto de sus desviaciones estándar. Esta normalización hace que el PCC sea un valor entre -1 y 1, donde -1 indica una correlación lineal negativa perfecta, 1 una correlación lineal positiva perfecta y 0 ninguna correlación lineal. Es importante tener en cuenta que el PCC solo detecta relaciones lineales, no otros tipos de correlaciones.",
        para2:
          "Dados los datos emparejados {(X,Y)} de n pares, el PCC se calculará utilizando la siguiente fórmula:",
      },
      cumulativeReturn: {
        title: "Rendimiento acumulado",
        para1:
          "Presentado como un porcentaje, el **rendimiento acumulado** de una inversión es la cantidad total que la inversión ha ganado o perdido con el tiempo.",
        para2:
          "El **rendimiento acumulado** se puede deducir fácilmente de un gráfico que muestra el crecimiento de una inversión, como el anterior. Utilizando solo los primeros y últimos valores del gráfico, podemos obtener el rendimiento acumulado total para un período de tiempo determinado.",
      },
      informationRatio: {
        title: "Ratio de información",
        para1:
          "Las estrategias de inversión a menudo se miden con respecto a una referencia determinada que en su mayoría consiste en uno o una mezcla de muchos índices. Cuando un gestor de inversiones supera la referencia, es interesante para el inversor saber a qué coste se ha logrado el objetivo. El **ratio de información** es una medida que proporciona una comparación entre el exceso de rendimiento con respecto a la referencia y el error de seguimiento, que es una medida de coherencia entre la estrategia y la referencia.",
        para2:
          "El **ratio de información** se calcula de la misma manera que el ratio de Sharpe, suponiendo que la referencia es igual a un rendimiento sin riesgo con una volatilidad del 0%.",
        para3:
          "En igualdad de condiciones, si este ratio es positivo, cuanto mayor sea, más robusta será la inversión. Un ratio alto significa que las fluctuaciones diarias en los rendimientos excesivos con respecto a la referencia son pequeñas en comparación con el exceso de rendimiento promedio con respecto a la referencia.",
      },
      kurtosis: {
        title: "Curtosis",
        para: "La curtosis indica la altura de una distribución. Para una distribución normal, la curtosis es 0. Cuanto mayor sea la curtosis de una distribución, más concentrada estará alrededor de su media.",
      },
      m2RiskAdjustedPerf: {
        title: "Medida M2",
        para1:
          "El rendimiento ajustado al riesgo M2 (M-cuadrado), también conocido como medida M2, evalúa los rendimientos ajustados al riesgo de una cartera de inversión. Evalúa los rendimientos de la cartera, teniendo en cuenta su riesgo en comparación con una referencia, como el mercado. Esencialmente, representa la diferencia en el exceso de rendimiento ajustado de una cartera (P) con respecto al mercado, ajustando la cartera para que coincida con la volatilidad del mercado. Originario del ratio de Sharpe, ofrece un beneficio sustancial al expresar los resultados en rendimientos porcentuales, a diferencia del ratio de Sharpe, que es una cifra no negativa y menos práctica para muchos inversores. Esta característica de la medida de Modigliani la hace significativamente más fácil de entender y aplicar.",
        para2:
          "En igualdad de condiciones, si el rendimiento de la inversión es superior al tipo sin riesgo, cuanto mayor sea la medida M2, mejor será la inversión. De hecho, en este caso la medida M2 aumenta cuando el rendimiento de la estrategia aumenta, o cuando la volatilidad de la estrategia disminuye con respecto a la de su referencia.",
      },
      maximumDrawdown: {
        title: "Caída máxima",
        para1:
          "Una **caída máxima** es la pérdida máxima observada desde un pico hasta un mínimo de una cartera, antes de que se alcance un nuevo pico. La **caída máxima** es un indicador del riesgo de caída durante un período de tiempo especificado.",
        para2:
          "La **caída máxima** es un indicador que se utiliza para evaluar el riesgo relativo de una estrategia frente a otra, ya que se centra en la preservación del capital, que es una preocupación clave para la mayoría de los inversores. Se prefiere una caída máxima baja, ya que esto indica que las pérdidas de las inversiones fueron pequeñas. Si una inversión nunca perdiera un centavo, la **caída máxima** sería cero. La peor **caída máxima** posible sería del 100%, lo que significa que la inversión no tiene ningún valor.",
        para3:
          "En igualdad de condiciones, cuanto menor sea el valor absoluto de la caída máxima (es decir, cuanto más cerca esté la caída máxima del 0%), más fiable será la inversión.",
        keyPoints: "Puntos clave",
        keyPoint1:
          "La caída máxima es una medida de la mayor caída de precio de un activo desde un pico hasta un mínimo.",
        keyPoint2:
          "La caída máxima se considera un indicador del riesgo de caída, y las grandes caídas máximas sugieren que los movimientos a la baja podrían ser volátiles.",
        keyPoint3:
          "Si bien la caída máxima mide la mayor pérdida, no tiene en cuenta la frecuencia de las pérdidas ni el tamaño de las ganancias.",
      },
      metaInfo: { title: "Plataforma - Base de conocimientos" },
      omegaRatio: {
        title: "Ratio de Omega",
        para1:
          "El ratio de Omega es una medida de rendimiento-riesgo. Calcula el ratio ponderado por la probabilidad de las ganancias frente a las pérdidas.",
        para2: "En igualdad de condiciones, cuanto mayor sea el ratio, mejor será la inversión.",
      },
      painRatio: {
        title: "Pain ratio",
        para1:
          "Al igual que el ratio de Calmar, el ratio de Pain se utiliza para determinar el exceso de rentabilidad en relación con el riesgo de pérdida máxima (drawdown) de un producto de inversión.",
        para2: "En igualdad de condiciones, cuanto mayor sea el ratio, mejor será la inversión.",
      },
      returnVolatilityRatio: {
        title: "Ratio de rendimiento a volatilidad",
        para1:
          "El **ratio de rendimiento a volatilidad** representa el rendimiento promedio logrado por unidad de volatilidad (desviación estándar), que puede interpretarse como una unidad de riesgo. Por lo tanto, informa sobre lo bien que se compensa a un inversor por el riesgo asumido (cuanto mayor sea el **ratio de rendimiento a volatilidad**, mayor será la compensación por el riesgo).",
        para2:
          "Normalmente, cualquier **ratio de rendimiento a volatilidad** superior a 1.0 durante un período de tiempo prolongado se considera bueno porque significa que las recompensas son más altas que el riesgo asumido. Por ejemplo, si la volatilidad anualizada es inferior al rendimiento anualizado, el **ratio de rendimiento a volatilidad** será superior a 1.0.",
        para3:
          "Por lo tanto, el **ratio de rendimiento a volatilidad** permite a los inversores comparar inversiones muy diferentes con los mismos criterios. El **ratio de rendimiento a volatilidad** permite comparaciones entre inversiones dispares.",
        keyPoints: "Puntos clave",
        keyPoint1:
          "Un **ratio de rendimiento a volatilidad** alto indica lo bien que se compensa a un inversor por el riesgo asumido.",
        keyPoint2:
          "El **ratio de rendimiento a volatilidad** ajusta el rendimiento pasado de una cartera al riesgo asumido por el inversor y, por lo tanto, permite una comparación entre inversiones muy diferentes.",
      },
      sharpeRatio: {
        title: "Ratio de Sharpe",
        para1:
          "El **ratio de Sharpe** es una medida del rendimiento ajustado al riesgo. Compara el exceso de rendimiento por encima de una inversión sin riesgo con el riesgo que se ha asumido para lograr este rendimiento, mientras que el riesgo para el inversor se define como volatilidad. El ratio ayuda a comprender el rendimiento que se ha logrado por unidad de riesgo y se puede utilizar para comparar múltiples oportunidades de inversión.",
        para2:
          "Dado que ninguna inversión está totalmente libre de riesgos, cualquier valor con pequeños riesgos puede usarse como un sustituto de los rendimientos sin riesgo. Por lo general, los bonos del gobierno de países estables se ajustan bien al propósito. Utilizamos los tipos LIBOR a corto plazo para calcular el rendimiento sin riesgo.",
        para3:
          "En igualdad de condiciones, si este ratio está definido (es decir, si es positivo), cuanto mayor sea, más robusta será la inversión. Un ratio alto significa que las fluctuaciones diarias en los rendimientos excesivos son pequeñas en comparación con el exceso de rendimiento promedio.",
      },
      skewness: {
        title: "Asimetría",
        para1:
          "La frecuencia de ocurrencia de grandes rendimientos en una dirección particular se mide por la **asimetría**. Si la frecuencia de ocurrencia de grandes rendimientos negativos en comparación con los grandes rendimientos positivos es mayor, entonces la distribución muestra una **asimetría** negativa. En caso de que la frecuencia de grandes rendimientos positivos supere la de los grandes rendimientos negativos, la distribución muestra una **asimetría** positiva.",
        para2:
          "Los inversores deben observar la **asimetría** porque considera los extremos de los rendimientos en lugar de centrarse únicamente en el promedio. Los inversores a corto y medio plazo en particular deben observar los extremos porque es menos probable que mantengan una estrategia el tiempo suficiente para confiar en que el promedio se resolverá.",
      },
      sortinoRatio: {
        title: "Ratio de Sortino",
        para1:
          "El ratio de Sortino es similar al ratio de Sharpe, excepto que utiliza el riesgo de caída (volatilidad de caída) en el denominador. Dado que la variabilidad al alza no es necesariamente algo malo, el ratio de Sortino es a veces más preferible que el ratio de Sharpe.",
        para2: "En igualdad de condiciones, cuanto mayor sea el ratio, mejor será la inversión.",
      },
      trackingError: {
        title: "Error de seguimiento",
        para1:
          "El **error de seguimiento** es una medida del riesgo de una cartera de inversión debido a las decisiones de su gestor de desviarse de su referencia. Cuanto mayor sea, más activo será el gestor al decidir desviarse de su referencia.",
        para2:
          "Matemáticamente, una forma relevante de estimarlo es calcular la desviación estándar de la diferencia en el rendimiento entre la cartera y la referencia. El que presentamos en esta plataforma está anualizado.",
        para3:
          "Es importante tener en cuenta que no representa la relevancia de las decisiones del gestor, sino el impacto que tienen en la cartera final. Por lo tanto, dos carteras con un rendimiento excelente o malo pueden tener un **error de seguimiento** alto en comparación con su referencia.",
        para4:
          "Un error de seguimiento bajo implica que una inversión no se desvía mucho de su referencia. Un error de seguimiento alto significa que la inversión se desvía mucho de su referencia.",
      },
      treynorRatio: {
        title: "Ratio de Treynor",
        para: 'Similar al ratio de Sharpe, el ratio de Treynor es una medida de eficiencia que utiliza la relación entre el rendimiento anualizado ajustado al riesgo y el riesgo. A diferencia del ratio de Sharpe, el ratio de Treynor utiliza el riesgo "de mercado" (beta) en lugar del riesgo total (desviación estándar). Un buen rendimiento de eficiencia se mide por un ratio alto.',
      },
      valueAtRisk: {
        title: "Valor en riesgo",
        para1:
          "El VaR es una estadística que cuantifica la magnitud de las pérdidas posibles dentro de una cartera durante un período de tiempo específico y con una probabilidad definida. VaR 1% en 1 mes = x% de pérdida en 1 mes con un 1% de probabilidad. ¡Cuanto más bajo, mejor!",
        para2:
          "En la práctica, es el cuantil de los rendimientos de la estrategia correspondiente al valor p (1% o 5%).",
      },
    },
  },
  home: {
    currency: "Moneda",
    inceptionToDateReturn: "Rendimiento desde el inicio",
    isin: "ISIN",
    lastChange: "Último cambio",
    lastDate: "Última fecha",
    lastDay: "Cambio del último día",
    lastPrice: "Último precio",
    metaInfo: { title: (ctx) => `${ctx.named("orgName")} - Plataforma` },
    modifyInvestorProfile: "Modificar perfil de inversor",
    na: "N/D",
    noDataInTable: "No hay productos para mostrar.",
    noProductsAvailable: "No hay productos disponibles para su rol y perfil de inversor.",
    productName: "Nombre del producto",
    products: "Productos",
    search: "Buscar",
    showMoreProducts: "Mostrar más productos",
    viewDetails: "Ver detalles",
    yearToDateReturn: "Rendimiento en lo que va de año",
  },
  products: {
    analysis: {
      analysisPeriod: "Período de análisis",
      backtest: "Retrospectivo",
      backtestOrLive: "Retrospectivo o en vivo",
      benchmarks: "Referencias",
      live: "En vivo",
      liveProduct: (ctx) => `${ctx.named("productName")} en vivo`,
      shareClass: "Clase de acciones",
      graphs: {
        considerApproximation: "Estos valores deben considerarse como una aproximación.",
        titles: {
          beta: "Beta",
          diffMonthlyReturns: "Diferencia de rendimientos mensuales",
          drawdowns: "Caídas",
          exposureIndices: "Exposición a los índices",
          exposureOverTime: "Exposición a lo largo del tiempo",
          monthlyReturns: "Rendimientos mensuales",
          performance: "Rendimiento",
          relativeDrawdowns: "Caídas relativas",
          relativePerformance: "Rendimiento relativo",
          riskAdjustedPerformance: "Rendimiento ajustado al riesgo",
          statistics: "Estadísticas",
          returnProfile: "Perfil de rendimiento",
          volatility: "Volatilidad",
          weightedPerformance: "Rendimiento ponderado",
          yearlyReturns: "Rendimientos anuales",
        },
        tooltips: {
          beta: "Este gráfico muestra el beta de nuestro producto en comparación con nuestra referencia. Para calcularlo, utilizamos datos del último año disponible, por lo que la métrica falta durante el primer año de vida de nuestro producto.",
          relativePerformance:
            "Este gráfico muestra una comparación del rendimiento de nuestro producto y el rendimiento de nuestra referencia. Para ello, nuestros rendimientos acumulados se dividen por los rendimientos acumulados de nuestra referencia. Esto significa que al 100%, ambos rendimientos son similares, de lo contrario, cuanto mayor sea el número, mejor será el rendimiento de nuestro producto en comparación con la referencia.",
          riskAdjustedPerformance:
            "Este gráfico muestra el rendimiento ajustado al riesgo. Para calcularlo, utilizamos datos del último año disponible, por lo que la métrica falta durante el primer año de vida de nuestro producto. El rendimiento ajustado al riesgo se define como el ratio entre el rendimiento anualizado y la volatilidad anualizada.",
          volatility:
            "Este gráfico muestra la volatilidad anualizada (es decir, la desviación estándar). Para calcularla, utilizamos datos del último año disponible, por lo que la métrica falta durante el primer año de vida de nuestro producto.",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Análisis` },
      tab: {
        historical: "Histórico",
        historicalText:
          'Para los productos que ya se han lanzado, distinguimos la sección "Análisis" entre "Análisis en vivo" y "Análisis histórico". La sección "Análisis histórico" tiene como objetivo ilustrar el rendimiento del producto antes de su inicio. El rendimiento se basa en una simulación realista de la estrategia. Sin embargo, no se involucraron activos bajo gestión durante el período de tiempo correspondiente.',
        internal: "Interno",
        live: "En vivo",
        liveText:
          'Para los productos que ya se han lanzado, distinguimos la sección "Análisis" entre "Análisis en vivo" y "Análisis histórico". La sección "Análisis en vivo" ilustra el rendimiento desde el inicio del producto.',
      },
    },
    documentDownload: {
      download: "Descargar",
      failure: "El archivo no se pudo descargar, contáctenos si esto es inesperado.",
      needAuth: "Debe estar autenticado para descargar este documento. Por favor, inicie sesión.",
      preparing: "El archivo se está preparando para la descarga...",
      success: "El archivo se ha descargado correctamente.",
      tapToDownload: "El archivo está listo. Pulse el botón de abajo para descargarlo.",
      metaInfo: {
        title: (ctx) => `${ctx.named("productName")} - Descarga de documentos`,
      },
    },
    documents: {
      validAsOfDate: (ctx) => `Válido a partir de: ${ctx.named("validAsOfDate")}`,
      addFile: "Añadir un archivo",
      cannotEditNameBecauseSyncedTooltip:
        "El nombre de este documento no se puede editar porque está sincronizado desde otra fuente.",
      document: "Documento",
      nameValidationError:
        "El nombre ya está siendo utilizado por otro de sus documentos. Elija uno diferente.",
      noDocument: "No se ha proporcionado ningún documento para este producto.",
      noArchivedDocument: "No hay documentos archivados para este producto.",
      noteDragAndDrop: "Nota: Arrastre y suelte las filas para reordenar los documentos.",
      shareClass: "Clase de acciones",
      syncedIconTooltip: "Este documento se sincroniza automáticamente desde otra fuente.",
      archiveIconTooltip: "Archivar",
      unarchiveIconTooltip: "Desarchivar",
      archivedDocumentsCardTitle: "Documentos archivados",
      dialog: {
        fileDeletion: {
          title: "Eliminación de archivo",
          text: "Va a eliminar completamente el archivo y no podrá acceder a él nunca más. ¿Está seguro?",
        },
        fileArchiving: {
          title: "Archivo",
          text: 'Va a archivar este archivo, lo que significa que irá a sus "documentos archivados" (justo debajo de los documentos). Tenga en cuenta que será posible desarchivarlo. ¿Quiere archivarlo?',
        },
        fileUnarchiving: {
          title: "Desarchivado de archivo",
          text: "Va a desarchivar este archivo, lo que significa que volverá a sus documentos normales. ¿Quiere desarchivarlo?",
        },
        needLogin: {
          text: "Para descargar este documento, debe estar autenticado.",
          title: "Debe estar autenticado",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Documentos` },
      notify: {
        savingDocumentsError:
          "Se produjo un error al intentar actualizar los documentos. Vuelva a intentarlo más tarde o contáctenos.",
        savingDocumentsSuccess: "Documentos actualizados correctamente.",
        fileDownloadError: "Error al descargar el documento, contáctenos.",
      },
      prompt: {
        file: "Archivo",
        fileDisplayName: "Nombre a mostrar del archivo",
        fileLanguage: "Idioma del archivo",
        loginRequired: "¿Requiere inicio de sesión?",
        shouldConsiderLastFactsheet:
          "¿Debe considerarse este archivo como la última factsheet del producto?",
        validAsOfDate: "Válido a partir de",
        addDocument: {
          title: "Añadir documento",
        },
        editDocumentMetadata: {
          title: "Editar documento",
        },
        editDocumentMetadataForLang: {
          title: (ctx) => `Editar archivo en ${ctx.named("lang")}`,
        },
      },
    },
    embedded: {
      perfGraph: {
        metaInfo: {
          title: (ctx) => `${ctx.named("productName")} - Gráfico de rendimiento incrustado`,
        },
      },
      perfTable: {
        currency: "Moneda",
        inceptionDate: "Fecha de inicio",
        name: "Nombre",
        lastPriceAsOf: "Último precio a partir de",
        mtd: "MTD",
        si: "SI",
        y1: "-1A",
        y3: "-3A",
        ytd: "YTD",
        metaInfo: {
          title: (ctx) => `${ctx.named("productName")} - Tabla de rendimiento incrustada`,
        },
      },
      statsTable: {
        feesIncluded: "Se incluyen las comisiones.",
        metaInfo: {
          title: (ctx) => `${ctx.named("productName")} - Tabla de estadísticas incrustada`,
        },
      },
    },
    events: {
      alquantUsLongShortEquityChfLive: "Alquant US Long/Short Equity en vivo",
      apexVolatilityLive: "Apex Volatility en vivo",
      covidCrisis: "Crisis de la COVID-19",
      crisis2022: "Crisis de 2022",
      december2018Crisis: "Crisis de diciembre de 2018",
      erfisaEquiflexAmcLive: "Equiflex en vivo",
      euroCrisis: "Crisis del euro",
      hbsUsLongShortEquityLive: "Dynamic Equity Exposure en vivo",
      financialCrisis: "Crisis financiera",
      convexusLive: "Convexus en vivo",
      lstsLive: "LSTS en vivo",
      popLive: "POP en vivo",
      protechLive: "ProTech en vivo",
      sinceInception: "Desde el inicio",
      ynnovationLive: "Ynnovation en vivo",
      calmgard: {
        calmgardCovid19Crisis: "Crisis de la Covid 19",
        calmgardEuroCrisisOne: "Crisis del euro I",
        calmgardEuroCrisisTwo: "Crisis del euro II",
        calmgardGreekAndChinaCrisis: "Crisis griega y china",
        calmgardInterestRateSpeculationOne: "Especulación de tipos de interés I",
        calmgardInterestRateSpeculationTwo: "Especulación de tipos de interés II",
        calmgardPostFinancialCrisis: "Post Crisis financiera",
        calmgardUkraineWar: "Guerra de Ucrania",
      },
      falgom: {
        falgomCoronavirusPandemic: "Pandemia de coronavirus",
        falgomFedQuantitativeTapering: "Reducción gradual de la FED",
        falgomGlobalFinancialCrisis: "Crisis financiera mundial",
        falgomGrowthSlowdownChina: "Desaceleración del crecimiento de China",
        falgomRecessionEurope: "Recesión en Europa",
        falgomVolmageddon: "Volmageddon",
      },
      sixt: {
        sixtGlobalEquityValueSinceNewModel: "Desde el nuevo modelo",
      },
      winvest: {
        winvestInterestRateShock: "Impacto de los tipos de interés 2022-2024",
        winvestModelSimulation: "Simulación de modelo",
        winvestModelSinceLaunch: "Desde el lanzamiento",
      },
    },
    report: {
      firstDateToInclude: "Primera fecha a incluir (aaaa-mm-dd)",
      lastDateToInclude: "Última fecha a incluir (aaaa-mm-dd)",
      nameValidationError:
        "El nombre ya está siendo utilizado por otro de sus documentos. Elija uno diferente.",
      tooManyPagesGeneratedError:
        "Se generaron demasiadas páginas. Póngase en contacto con nuestro equipo de soporte para resolver este problema.",
      shareClass: "Clase de acciones",
      year: "Año",
      cardTitle: {
        contacts: "Contactos",
        description: "Descripción",
        disclaimer: "Aviso legal",
        drawdowns: "Caídas",
        monthlyComment: "Comentario mensual",
        monthlyPerformance: "Rendimiento mensual",
        monthlyReturns: "Rendimientos mensuales",
        historicalPrices: "Precios históricos",
        productDetails: "Detalles del producto",
        relativePerformance: "Rendimiento relativo",
        riskProfile: "Perfil de riesgo",
        shareClasses: "Clases de acciones",
        volatility: "Volatilidad",
        yearlyPerformance: "Rendimiento anual",
      },
      dragAndDrop: {
        addGenericComponent: "Añadir componente genérico",
        addPortfolioBreakdownOnDate: "Añadir desglose de cartera a una fecha determinada",
        addPortfolioBreakdownOverTime: "Añadir desglose de cartera a lo largo del tiempo",
        addHoldingsTable: "Añadir tabla de posiciones",
        availableGenericComponents: "Componentes genéricos",
        availableHoldingComponents: "Componentes de holding",
        availableLiquidityRiskComponents: "Componentes de riesgo de liquidez",
        availablePerformanceRiskComponents: "Componentes de riesgo de rendimiento",
        availablePredefinedComponents: "Componentes predefinidos",
        editReport: "Editar informe",
        componentTooBig: "El componente es demasiado grande para caber en una sola página.",
        saveSuccessText: "La configuración del informe se actualizó correctamente.",
        stopEdit: "Detener edición",
        footer: {
          title: "Pie de página",
          page: "Página",
        },
        forcedElementDeletionWarning: {
          componentsWereRemoved:
            "Algunos componentes se han eliminado de su diseño debido a que su tamaño excede el área visible de una sola página o su columna contenedora es demasiado grande. Los ID de los componentes eliminados son:",
          resolveSolution:
            "Para resolver este problema, reduzca la altura de los componentes afectados, coloque el componente en una nueva fila única o contáctenos.",
          title: "Eliminación forzada de componentes del diseño",
        },
        header: {
          title: "Encabezado",
        },
        style: {
          title: "Estilo",
        },
      },
      generateReport: {
        downloadReport: "Descargar informe",
        generatingReport: "Generando informe...",
        saveReport: "Guardar informe en Documentos",
        notify: {
          generatingError: "Error al generar un informe, contáctenos.",
          savedInDocumentsSection: "Su informe se ha guardado en la sección Documentos.",
        },
        prompt: {
          acceptText: "Guardar informe",
          considerLastFactsheet:
            "¿Debe considerarse este archivo como la última factsheet para el producto?",
          fileDisplayName: "Nombre de visualización del archivo",
          loginRequired: "¿Se requiere inicio de sesión?",
          title: "Generar y cargar informe",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Informe` },
      shareClassesTable: {
        bloomberg: "Bloomberg",
        class: "Clase",
        currency: "Moneda",
        inception: "Inicio",
        isin: "ISIN",
        mgmtFee: "Com. gest.",
        minInvestment: "Inv. mín.",
        mtdPerf: "Rend. MTD",
        nav: "NAV",
        navDate: "Fecha NAV",
        perfFee: "Com. rend.",
        siPerf: "Rend. SI",
        ter: "TER",
        ytdPerf: "Rend. YTD",
      },
      statistics: {
        title: "Estadísticas",
      },
      statisticsWithPeriods: {
        title: "Rendimiento",
        periods: {
          1: "1M",
          3: "3M",
          6: "6M",
          ytd: "YTD",
          12: "1A",
          36: "3A",
          60: "5A",
          84: "7A",
          120: "10A",
          max: "MÁX",
        },
      },
    },
    months: {
      short: {
        jan: "Ene",
        feb: "Feb",
        mar: "Mar",
        apr: "Abr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Ago",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dic",
      },
    },
    overview: {
      aum: "AUM",
      aumDescription:
        "El AUM (Activos bajo gestión) se refiere al valor de mercado total de los activos gestionados dentro de este producto de inversión.",
      download: "Descargar",
      keyCharacteristics: "Características clave",
      historicalPrices: "Precios históricos",
      itd: "Rendimiento ITD",
      itdDescription: (ctx) =>
        `ITD (desde el inicio hasta la fecha) es un período, que comienza desde el inicio del producto (${ctx.named(
          "date"
        )}), y continúa hasta el día de hoy.`,
      lastChange: "Último cambio",
      lastDayChange: "Cambio del último día",
      latestFactsheet: "Último factsheet",
      lastWeekChange: "Cambio de la última semana",
      lastMonthChange: "Cambio del último mes",
      lastQuarterChange: "Cambio del último trimestre",
      lastYearChange: "Cambio del último año",
      monthlyReturns: "Rendimientos mensuales",
      mtd: "Rendimiento MTD",
      mtdDescription:
        "MTD (Month-to-Date) es un periodo que abarca desde el inicio del mes natural en curso hasta la fecha actual.",
      performance: "Rendimiento",
      productDetails: "Detalles del producto",
      productTimeline: "Cronología del producto",
      shareClass: "Clase de acciones",
      yearlyReturns: "Rendimientos anuales",
      ytd: "Rendimiento YTD",
      ytdDescription:
        "YTD (en lo que va de año) es un período, que comienza desde el inicio del año natural actual y continúa hasta el día de hoy.",
      dragAndDrop: {
        addGenericComponent: "Añadir componente genérico",
        addPortfolioBreakdownOnDate: "Añadir desglose de cartera a una fecha determinada",
        addPortfolioBreakdownOverTime: "Añadir desglose de cartera a lo largo del tiempo",
        addHoldingsTable: "Añadir tabla de posiciones",
        availableGenericComponents: "Componentes genéricos",
        availableHoldingComponents: "Componentes de holding",
        availableLiquidityRiskComponents: "Componentes de riesgo de liquidez",
        availablePerformanceRiskComponents: "Componentes de riesgo de rendimiento",
        availablePredefinedComponents: "Componentes predefinidos",
        editOverview: "Editar resumen",
        saveSuccessText: "La configuración del resumen se actualizó correctamente.",
        stopEdit: "Detener edición",
        style: {
          title: "Estilo",
        },
      },
      follow: {
        buttonText: "Seguir",
        buttonTextFollowing: "Siguiendo",
        notify: {
          error: "Hubo un error. Vuelva a intentarlo o contáctenos si el problema persiste.",
          followSuccess: (ctx) => `Ahora está siguiendo a ${ctx.named("productName")}.`,
          unfollowSuccess: (ctx) => `Ya no está siguiendo a ${ctx.named("productName")}.`,
        },
        promptNotFollowing: {
          acceptText: "Seguir",
          text: "Al seguir este producto, acepta que se le envíe información relacionada con el producto de vez en cuando. Siempre podrá dejar de seguir para dejar de recibir dicha información.",
          title: "Seguir producto",
        },
        promptFollowing: {
          acceptText: "Dejar de seguir",
          text: "Actualmente está siguiendo este producto. ¿Quiere dejar de seguirlo, lo que significa que no recibirá información relacionada con el producto?",
          title: "Dejar de seguir producto",
        },
        promptNotLoggedIn: {
          cancelText: "Crear una cuenta",
          text: "Si desea poder seguir este producto, debe iniciar sesión en su cuenta. Si no tiene una cuenta, puede crear una de forma gratuita.",
          title: "Seguir producto",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Resumen` },
      statsOptions: {
        1: "1 mes",
        3: "3 meses",
        6: "6 meses",
        ytd: "En lo que va de año",
        12: "1 año",
        36: "3 años",
        60: "5 años",
        84: "7 años",
        120: "10 años",
        max: "Desde el inicio",
      },
    },
  },
  settings: {
    metaInfo: { title: (ctx) => `Configuración - ${ctx.named("name")}` },
    changePassword: {
      buttonReset: "Enviar un correo electrónico para restablecer la contraseña",
      title: "Cambiar contraseña",
      notify: {
        success: {
          title: "Correo electrónico de restablecimiento enviado",
          text: (ctx) =>
            `Se ha enviado un correo electrónico de restablecimiento a la bandeja de entrada de ${ctx.named(
              "email"
            )}. Si no aparece en breve, revise la bandeja de spam.`,
        },
        failure:
          "No pudimos cambiar su contraseña, por favor contáctenos a través del formulario de contacto para solucionar este error.",
      },
    },
    deleteAccount: {
      deleteYourAccount: "Eliminar su cuenta",
      title: "Eliminar cuenta",
      notify: {
        success: "Su cuenta se eliminó correctamente.",
      },
      dialog: {
        permanentlyDeleteData: {
          text: "La eliminación de su cuenta eliminará permanentemente todos sus datos.",
          title: "Confirmar",
        },
        recentLoginNeeded: "Se requiere un inicio de sesión reciente",
      },
    },
    editProfile: {
      company: "Empresa",
      email: "Correo electrónico",
      firstName: "Nombre de pila",
      investorProfileCountry: "País",
      investorProfileType: "Tipo de inversor",
      lastName: "Apellido",
      phone: "Teléfono",
      title: "Editar perfil",
      requiredFields:
        'Los campos marcados con <span class="text-danger">*</span> son obligatorios.',
      dialog: {
        askValidation: {
          title: "Verificación de datos personales",
          text: "Revise sus datos personales y guárdelos cuando haya terminado.",
        },
      },
      notify: {
        errorText:
          "No pudimos actualizar sus datos, por favor contáctenos a través del formulario de contacto para solucionar este error.",
        successText: "La actualización fue un éxito",
      },
    },
    overview: {
      email: "Correo electrónico",
      name: "Nombre",
      title: "Resumen de la cuenta",
    },
  },
};
